webpackJsonp([0],{

/***/ "./common.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("../../node_modules/jquery/dist/jquery.slim.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_js_src_dropdown_js__ = __webpack_require__("../../node_modules/bootstrap/js/src/dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_js_src_collapse_js__ = __webpack_require__("../../node_modules/bootstrap/js/src/collapse.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_js_src_tab_js__ = __webpack_require__("../../node_modules/bootstrap/js/src/tab.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__("../../node_modules/react-dom/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_serviceStatus__ = __webpack_require__("./util/serviceStatus.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_production__ = __webpack_require__("./util/production.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components__ = __webpack_require__("./components/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();











Object(__WEBPACK_IMPORTED_MODULE_6__util_serviceStatus__["a" /* checkServiceStatus */])();

__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.render(_jsx(__WEBPACK_IMPORTED_MODULE_8__components__["z" /* Search */], {}), document.getElementById('search'));

if (true) {
  Object(__WEBPACK_IMPORTED_MODULE_7__util_production__["a" /* fillLanguageDropdown */])();
}

/***/ }),

/***/ "./components/Activity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Activity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__haroenv_react_sparklines__ = __webpack_require__("../../node_modules/@haroenv/react-sparklines/build/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__haroenv_react_sparklines___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__haroenv_react_sparklines__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./util/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__("./components/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_1__haroenv_react_sparklines__["SparklinesLine"], {
  color: '#2C8EBB'
});

var Activity = function Activity(_ref) {
  var graphData = _ref.graphData,
      graphLink = _ref.graphLink,
      lastCommit = _ref.lastCommit,
      commitsLastThreeMonths = _ref.commitsLastThreeMonths;

  if (!graphData && !graphLink && !lastCommit && !commitsLastThreeMonths) {
    return null;
  }

  return _jsx('article', {
    className: 'details-side--activity'
  }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.activity), graphData && _jsx('a', {
    href: graphLink,
    target: '_blank',
    rel: 'noopener noreferrer'
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__haroenv_react_sparklines__["Sparklines"], {
    data: graphData,
    width: 100,
    height: 15
  }, void 0, _ref2)), _jsx('dl', {}, void 0, commitsLastThreeMonths >= 0 && _jsx(__WEBPACK_IMPORTED_MODULE_3____["i" /* Di */], {
    icon: 'commits',
    title: window.i18n.detail.commits_last_three_months,
    description: commitsLastThreeMonths
  }), lastCommit && _jsx(__WEBPACK_IMPORTED_MODULE_3____["i" /* Di */], {
    icon: 'commits-last',
    title: window.i18n.detail.last_commit,
    description: lastCommit
  })));
};

/***/ }),

/***/ "./components/Aside.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Aside; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("./components/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./util/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var Aside = function Aside(_ref) {
  var name = _ref.name,
      homepage = _ref.homepage,
      repository = _ref.repository,
      contributors = _ref.contributors,
      activity = _ref.activity,
      downloads = _ref.downloads,
      humanDownloads = _ref.humanDownloads,
      stargazers = _ref.stargazers,
      dependents = _ref.dependents,
      humanDependents = _ref.humanDependents,
      dependencies = _ref.dependencies,
      tags = _ref.tags,
      versions = _ref.versions,
      version = _ref.version,
      devDependencies = _ref.devDependencies,
      bundlesize = _ref.bundlesize,
      onOpenFileBrowser = _ref.onOpenFileBrowser,
      jsDelivrHits = _ref.jsDelivrHits;
  return _jsx('aside', {
    className: 'details-side col-lg-4'
  }, void 0, _jsx('article', {
    className: 'details-side--links'
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1____["g" /* DetailLinks */], {
    name: name,
    homepage: homepage,
    repository: repository
  })), _jsx(__WEBPACK_IMPORTED_MODULE_1____["p" /* Install */], {
    name: name,
    onOpenFileBrowser: onOpenFileBrowser
  }), _jsx(__WEBPACK_IMPORTED_MODULE_1____["c" /* Cdn */], {
    name: name,
    version: version
  }), _jsx(__WEBPACK_IMPORTED_MODULE_1____["w" /* Popularity */], {
    repository: repository,
    downloads: downloads,
    humanDownloads: humanDownloads,
    stargazers: stargazers,
    dependents: dependents,
    humanDependents: humanDependents,
    name: name,
    jsDelivrHits: jsDelivrHits
  }), repository && Object(__WEBPACK_IMPORTED_MODULE_2__util__["g" /* isKnownRepositoryHost */])(repository.host) && (repository.host === 'github.com' ? _jsx(__WEBPACK_IMPORTED_MODULE_1____["l" /* GithubActivity */], {
    data: activity,
    repository: repository
  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["a" /* Activity */], _extends({}, activity, { repository: repository }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["D" /* Usage */], _extends({
    dependencies: dependencies,
    devDependencies: devDependencies,
    bundlesize: bundlesize
  }, Object(__WEBPACK_IMPORTED_MODULE_2__util__["h" /* packageJSONLink */])(name))), _jsx(__WEBPACK_IMPORTED_MODULE_1____["B" /* Tags */], {
    tags: tags,
    name: name
  }), _jsx(__WEBPACK_IMPORTED_MODULE_1____["E" /* Versions */], {
    versions: versions
  }), _jsx(__WEBPACK_IMPORTED_MODULE_1____["d" /* Contributors */], {
    contributors: contributors
  }));
};

/***/ }),

/***/ "./components/Cdn.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Cdn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("./components/index.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var JsDelivr = function JsDelivr(_ref) {
  var name = _ref.name,
      version = _ref.version;
  return _jsx(__WEBPACK_IMPORTED_MODULE_1____["i" /* Di */], {
    title: 'jsDelivr',
    description: _jsx('a', {
      href: 'https://cdn.jsdelivr.net/npm/' + name + '@' + version + '/',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, void 0, 'cdn.jsdelivr.net/npm/', name, '/')
  });
};

var Unpkg = function Unpkg(_ref2) {
  var name = _ref2.name,
      version = _ref2.version;
  return _jsx(__WEBPACK_IMPORTED_MODULE_1____["i" /* Di */], {
    title: 'unpkg',
    description: _jsx('a', {
      href: 'https://unpkg.com/' + name + '@' + version + '/',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, void 0, 'unpkg.com/', name, '/')
  });
};

var BundleRun = function BundleRun(_ref3) {
  var name = _ref3.name,
      version = _ref3.version;
  return _jsx(__WEBPACK_IMPORTED_MODULE_1____["i" /* Di */], {
    title: 'bundle.run',
    description: _jsx('a', {
      href: 'https://bundle.run/' + name + '@' + version,
      target: '_blank',
      rel: 'noopener noreferrer'
    }, void 0, 'bundle.run/', name)
  });
};

var Cdn = function (_Component) {
  _inherits(Cdn, _Component);

  function Cdn(props) {
    _classCallCheck(this, Cdn);

    var _this = _possibleConstructorReturn(this, (Cdn.__proto__ || Object.getPrototypeOf(Cdn)).call(this, props));

    _this.cdns = {
      jsdelivr: JsDelivr,
      unpkg: Unpkg,
      bundlerun: BundleRun
    };

    _this.order = Object.keys(_this.cdns).sort(function () {
      return Math.random() - 0.5;
    });
    return _this;
  }

  _createClass(Cdn, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var items = this.order.map(function (key) {
        var Component = _this2.cdns[key];
        return _jsx(Component, {
          name: _this2.props.name,
          version: _this2.props.version
        }, key);
      });

      return _jsx('article', {
        className: 'details-side--cdns'
      }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.cdns), _jsx('dl', {}, void 0, items));
    }
  }]);

  return Cdn;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),

/***/ "./components/Contributors.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Contributors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("./components/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Contributors = function (_Component) {
  _inherits(Contributors, _Component);

  function Contributors() {
    _classCallCheck(this, Contributors);

    return _possibleConstructorReturn(this, (Contributors.__proto__ || Object.getPrototypeOf(Contributors)).apply(this, arguments));
  }

  _createClass(Contributors, [{
    key: 'render',
    value: function render() {
      var contributors = this.props.contributors;

      return _jsx('article', {
        className: 'details-side--contributors'
      }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.contributors), _jsx('ul', {
        className: 'list-unstyled m-2'
      }, void 0, contributors.map(function (contributor) {
        return _jsx('li', {
          className: 'mb-1'
        }, contributor.name, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["v" /* Owner */], contributor));
      })));
    }
  }]);

  return Contributors;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),

/***/ "./components/Copyable.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Copyable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var images = {
  default: '/assets/detail/ico-copy-default.svg',
  success: '/assets/detail/ico-copy-success.svg'
};

var Copyable = function (_Component) {
  _inherits(Copyable, _Component);

  function Copyable(props) {
    _classCallCheck(this, Copyable);

    var _this = _possibleConstructorReturn(this, (Copyable.__proto__ || Object.getPrototypeOf(Copyable)).call(this, props));

    _this.state = {
      statusImage: images.default
    };
    return _this;
  }

  _createClass(Copyable, [{
    key: 'copy',
    value: function copy(toCopy) {
      var _this2 = this;

      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;

      var setAndUnset = function setAndUnset(_ref) {
        var image = _ref.image,
            timeout = _ref.timeout;

        _this2.setState(function () {
          return {
            statusImage: image
          };
        });
        setTimeout(function () {
          _this2.setState(function () {
            return {
              statusImage: images.default
            };
          });
        }, timeout);
      };

      var range = document.createRange();
      range.selectNode(toCopy);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      try {
        // Now that we've selected the anchor text, execute the copy command
        var copy = document.execCommand('copy');
        window.getSelection().removeAllRanges();
        if (copy === true) {
          setAndUnset({ image: images.success, timeout: timeout });
        }
      } catch (err) {
        this.setState(function () {
          return {
            statusImage: images.default
          };
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          _props$tag = _props.tag,
          tag = _props$tag === undefined ? 'div' : _props$tag,
          pre = _props.pre,
          children = _props.children;

      var Content = tag;
      return _jsx('div', {
        className: 'copyable'
      }, void 0, _jsx(Content, {
        className: 'copyable--content'
      }, void 0, pre, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'span',
        { ref: function ref(text) {
            return _this3.copyText = text;
          } },
        children
      )), _jsx('button', {
        onClick: function onClick() {
          return _this3.copy(_this3.copyText);
        },
        className: 'copyable--button user-select-none'
      }, void 0, _jsx('img', {
        src: this.state.statusImage,
        alt: '',
        className: 'copyable--button__img'
      }), 'copy'));
    }
  }]);

  return Copyable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),

/***/ "./components/Deprecated.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Deprecated; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var Deprecated = function Deprecated(_ref) {
  var deprecated = _ref.deprecated;
  return deprecated ? _jsx("span", {
    className: "ais-Hit-deprecated",
    title: deprecated
  }, void 0, window.i18n.deprecated) : null;
};

/***/ }),

/***/ "./components/DetailLinks.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DetailLinks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("./components/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./util/index.js");
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var images = {
  homepage: '/assets/search/ico-home.svg',
  npm: '/assets/search/ico-npm.svg',
  github: '/assets/search/ico-github.svg',
  yarn: '/assets/search/ico-yarn.svg',
  gitlab: '/assets/search/ico-gitlab.svg',
  bitbucket: '/assets/search/ico-bitbucket.svg',
  generic_repo: '/assets/search/ico-git.svg'
};

var Link = function Link(_ref) {
  var site = _ref.site,
      url = _ref.url,
      display = _ref.display,
      _ref$Tag = _ref.Tag,
      Tag = _ref$Tag === undefined ? 'a' : _ref$Tag;
  return _jsx(Tag, {
    href: url,
    className: 'details-links--link details-links--link__' + site
  }, void 0, _jsx('img', {
    src: images[site],
    alt: ''
  }), display);
};

var RepositoryLink = function RepositoryLink(_ref2) {
  var repository = _ref2.repository;
  var host = repository.host,
      user = repository.user,
      path = repository.path,
      project = repository.project;


  if (!Object(__WEBPACK_IMPORTED_MODULE_2__util__["g" /* isKnownRepositoryHost */])(repository.host)) {
    return repository.url ? _jsx(Link, {
      site: 'generic_repo',
      url: repository.url,
      display: repository.url
    }) : null;
  }

  var _repository$host$spli = repository.host.split('.'),
      _repository$host$spli2 = _slicedToArray(_repository$host$spli, 1),
      provider = _repository$host$spli2[0];

  return _jsx(Link, {
    site: provider,
    url: 'https://' + host + '/' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* encode */])(user) + '/' + Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* encode */])(project) + (path || ''),
    display: user + '/' + project
  });
};

var _ref4 = _jsx('span', {
  className: 'text-hide'
}, void 0, 'https://');

var DetailLinks = function DetailLinks(_ref3) {
  var name = _ref3.name,
      homepage = _ref3.homepage,
      repository = _ref3.repository,
      className = _ref3.className;
  return _jsx('div', {
    className: 'detail-links'
  }, void 0, _jsx(Link, {
    site: 'yarn',
    display: _jsx(__WEBPACK_IMPORTED_MODULE_1____["e" /* Copyable */], {}, void 0, _jsx('a', {
      href: 'https://yarn.pm/' + name
    }, void 0, _ref4, 'yarn.pm/', name)),
    Tag: 'div'
  }), homepage ? _jsx(Link, {
    site: 'homepage',
    url: homepage,
    display: homepage.replace(/(http)?s?(:\/\/)?(www\.)?/, '')
  }) : null, repository ? _jsx(RepositoryLink, {
    repository: repository
  }) : null, _jsx(Link, {
    site: 'npm',
    url: 'https://www.npmjs.com/package/' + name,
    display: name
  }));
};

/***/ }),

/***/ "./components/Details.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Details; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bytes__ = __webpack_require__("../../node_modules/bytes/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bytes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bytes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__("../../node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_formatDistance__ = __webpack_require__("../../node_modules/date-fns/formatDistance/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_date_fns_formatDistance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_date_fns_formatDistance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__("./components/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_schema__ = __webpack_require__("./util/schema.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__("./util/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_config__ = __webpack_require__("./util/config.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var index = __WEBPACK_IMPORTED_MODULE_7__util_config__["b" /* client */].initIndex(__WEBPACK_IMPORTED_MODULE_7__util_config__["a" /* algolia */].indexName);

var readmeErrorMessage = 'ERROR: No README data found!';

function setHead(_ref) {
  var name = _ref.name,
      description = _ref.description;

  var head = document.querySelector('head');
  var permalink = 'https://classic.yarnpkg.com' + Object(__WEBPACK_IMPORTED_MODULE_6__util__["i" /* packageLink */])(name);
  head.querySelector('meta[property="og:title"]').setAttribute('content', name);
  document.title = name + ' | Yarn';
  head.querySelector('meta[name=description]').setAttribute('content', description);
  head.querySelector('meta[property="og:description"]').setAttribute('content', description);
  head.querySelector('meta[property="og:url"]').setAttribute('content', permalink);
  head.querySelector('link[rel=canonical]').setAttribute('href', permalink);
}

var OBJECT_DOESNT_EXIST = 'ObjectID does not exist';

var _ref9 = _jsx(__WEBPACK_IMPORTED_MODULE_4____["e" /* Copyable */], {
  pre: '$ '
}, void 0, 'yarn init');

var _ref10 = _jsx(__WEBPACK_IMPORTED_MODULE_4____["e" /* Copyable */], {
  pre: '$ '
}, void 0, 'yarn publish');

var Details = function (_Component) {
  _inherits(Details, _Component);

  function Details(props) {
    _classCallCheck(this, Details);

    var _this = _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).call(this, props));

    _this._getRepositoryStarCount = function () {
      var _this$state = _this.state,
          github = _this$state.github,
          gitlab = _this$state.gitlab,
          repository = _this$state.repository;


      if (!repository || !repository.host || repository.host === 'bitbucket.org') {
        return -1;
      }

      if (repository.host === 'github.com' && github) {
        return _this.state.github.stargazers_count;
      }
      if (repository.host === 'gitlab.com' && gitlab) {
        return _this.state.gitlab.star_count;
      }
      return 0;
    };

    _this._openFileBrowser = function (evt) {
      // Ignore if is already browsing the files (prevent pushing state to the history repeatedly)
      if (!_this.state.isBrowsingFiles) {
        _this._setFilesSearchParam(true);

        _this.setState({ isBrowsingFiles: true });
      }
      evt.preventDefault();
    };

    _this._closeFileBrowser = function (evt) {
      _this._setFilesSearchParam(false);

      _this.setState({ isBrowsingFiles: false });
      evt.preventDefault();
    };

    _this._setFilesSearchParam = function (active) {
      // The strictNullHandling option is used to avoid that the qs includes a '=' at the end of empty params
      var search = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.parse(location.search, {
        ignoreQueryPrefix: true,
        strictNullHandling: true
      });

      if (active) {
        search.files = null;
      } else {
        delete search.files;
      }

      window.history.pushState(null, null, location.pathname + __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(search, { addQueryPrefix: true, strictNullHandling: true }));
    };

    _this._onPopState = function (_ref2) {
      var state = _ref2.state;

      // Open or close the file browser based on the current search
      var _qs$parse = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.parse(location.search, { ignoreQueryPrefix: true }),
          files = _qs$parse.files;

      if (files !== undefined) {
        _this.setState({ isBrowsingFiles: true });
      } else if (_this.state.isBrowsingFiles) {
        _this.setState({ isBrowsingFiles: false });
      }
    };

    _this.getGithub = _this.getGithub.bind(_this);
    _this.state = _extends({}, __WEBPACK_IMPORTED_MODULE_5__util_schema__["a" /* default */], {
      isBrowsingFiles: false
    });
    return _this;
  }

  _createClass(Details, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      index.getObject(this.props.objectID).then(function (content) {
        _this2.setState(function (prevState) {
          return _extends({}, content, { loaded: true });
        });
        setHead(content);
        _this2.getDocuments();

        // Opens the file browser if the search has a 'files' param.

        var _qs$parse2 = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.parse(location.search, {
          ignoreQueryPrefix: true
        }),
            files = _qs$parse2.files;

        if (files !== undefined) {
          _this2.setState({ isBrowsingFiles: true });
        }
      }).catch(function (e) {
        if (e.message === OBJECT_DOESNT_EXIST) {
          _this2.setState({
            objectDoesntExist: true
          });
        }
      });

      window.addEventListener('popstate', this._onPopState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('popstate', this._onPopState);
    }
  }, {
    key: 'getGithub',
    value: function getGithub(_ref3) {
      var _this3 = this;

      var url = _ref3.url,
          state = _ref3.state;

      return Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* get */])({
        url: 'https://api.github.com/' + url,
        type: 'json'
      }).then(function (res) {
        return _this3.setState(_defineProperty({}, state, res));
      }).catch(function (err) {
        if (err === 'retry') {
          setTimeout(_this3.getGithub({ url: url, state: state }), 200);
        }
      });
    }

    // Get repository details, like stars, changelog, commit activity and so on

  }, {
    key: 'getRepositoryDetails',
    value: function getRepositoryDetails(_ref4) {
      var _this4 = this;

      var user = _ref4.user,
          project = _ref4.project,
          host = _ref4.host,
          branch = _ref4.branch,
          path = _ref4.path;
      var _state = this.state,
          readme = _state.readme,
          changelogFilename = _state.changelogFilename;

      var hasReadme = readme && readme.length > 0 && readme !== readmeErrorMessage;

      if (host === 'github.com') {
        if (changelogFilename) {
          Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* get */])({
            url: changelogFilename,
            type: 'text'
          }).then(function (res) {
            return _this4.setState({ changelog: res });
          });
        }

        if (!hasReadme) {
          this.setState({ readmeLoading: true });
          Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* get */])({
            url: Object(__WEBPACK_IMPORTED_MODULE_6__util__["j" /* prefixURL */])('README.md', {
              base: 'https://raw.githubusercontent.com',
              user: user,
              project: project,
              head: branch,
              path: path.replace(/\/tree\//, '')
            }),
            type: 'text'
          }).then(function (res) {
            return _this4.setState({ readme: res });
          }).catch(function () {
            return _this4.setState({ readmeLoading: false });
          });
        }

        this.getGithub({
          url: 'repos/' + user + '/' + project + '/stats/commit_activity',
          state: 'activity'
        });

        this.getGithub({
          url: 'repos/' + user + '/' + project,
          state: 'github'
        });
      } else if (host === 'gitlab.com') {
        var getGitlabFile = function getGitlabFile(_ref5) {
          var user = _ref5.user,
              project = _ref5.project,
              branch = _ref5.branch,
              filePath = _ref5.filePath;

          // We need to use the Gitlab API because the raw url does not support cors
          // https://gitlab.com/gitlab-org/gitlab-ce/issues/25736
          // So we need to 'translate' raw urls to api urls.
          // E.g (https://gitlab.com/janslow/gitlab-fetch/raw/master/CHANGELOG.md) -> (https://gitlab.com/api/v4/projects/janslow%2Fgitlab-fetch/repository/files/CHANGELOG.md?ref=master)
          // Once gitlab adds support, we can get rid of this workaround.
          var apiUrl = 'https://gitlab.com/api/v4/projects/' + user + '%2F' + project + '/repository/files/' + encodeURIComponent(filePath) + '?ref=' + branch;
          return Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* get */])({
            url: apiUrl,
            type: 'json'
          }).then(function (res) {
            return res.encoding === 'base64' && atob(res.content);
          });
        };

        Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* get */])({
          url: 'https://gitlab.com/api/v4/projects/' + user + '%2F' + project,
          type: 'json'
        }).then(function (res) {
          return _this4.setState({ gitlab: res });
        });

        // Fetch last commit
        Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* get */])({
          url: 'https://gitlab.com/api/v4/projects/' + user + '%2F' + project + '/repository/commits?per_page=1',
          type: 'json'
        }).then(function (_ref6) {
          var _ref7 = _slicedToArray(_ref6, 1),
              committed_date = _ref7[0].committed_date;

          _this4.setState({
            activity: {
              lastCommit: Object(__WEBPACK_IMPORTED_MODULE_6__util__["e" /* i18nReplaceVars */])(window.i18n.time_ago, {
                time_distance: __WEBPACK_IMPORTED_MODULE_3_date_fns_formatDistance___default()(new Date(committed_date), new Date())
              })
            }
          });
        });

        if (!hasReadme) {
          this.setState({ readmeLoading: true });

          getGitlabFile({
            user: user,
            project: project,
            branch: branch,
            filePath: path + '/README.md'
          }).then(function (res) {
            return _this4.setState({ readme: res });
          }).catch(function () {
            return _this4.setState({ readmeLoading: false });
          });
        }

        if (changelogFilename) {
          // Extract information from raw url
          var _changelogFilename$ma = changelogFilename.match(/^https?:\/\/gitlab.com\/([^/]+)\/([^/]+)\/raw\/([^/]+)\/(.*)$/i),
              _changelogFilename$ma2 = _slicedToArray(_changelogFilename$ma, 5),
              _user = _changelogFilename$ma2[1],
              _project = _changelogFilename$ma2[2],
              _branch = _changelogFilename$ma2[3],
              filePath = _changelogFilename$ma2[4];

          getGitlabFile({ user: _user, project: _project, branch: _branch, filePath: filePath }).then(function (res) {
            return _this4.setState({ changelog: res });
          });
        }
      } else if (host === 'bitbucket.org') {
        if (!hasReadme) {
          this.setState({ readmeLoading: true });

          Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* get */])({
            url: 'https://bitbucket.org/' + user + '/' + project + (path ? path.replace('src', 'raw') : '/raw/' + branch) + '/README.md',
            type: 'text',
            redirect: 'error' // Prevent being redirected to login page
          }).then(function (res) {
            return _this4.setState({ changelog: res });
          }).catch(function () {
            return _this4.setState({ readmeLoading: false });
          });
        }

        // Fetch last commit
        Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* get */])({
          url: 'https://api.bitbucket.org/2.0/repositories/' + user + '/' + project + '/commits?pagelen=1',
          type: 'json'
        }).then(function (_ref8) {
          var _ref8$values = _slicedToArray(_ref8.values, 1),
              date = _ref8$values[0].date;

          _this4.setState({
            activity: {
              lastCommit: Object(__WEBPACK_IMPORTED_MODULE_6__util__["e" /* i18nReplaceVars */])(window.i18n.time_ago, {
                time_distance: __WEBPACK_IMPORTED_MODULE_3_date_fns_formatDistance___default()(new Date(date), new Date())
              })
            }
          });
        });

        if (changelogFilename) {
          Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* get */])({
            url: changelogFilename,
            type: 'text',
            redirect: 'error' // Prevent being redirected to login page
          }).then(function (res) {
            return _this4.setState({ changelog: res });
          });
        }
      }
    }
  }, {
    key: 'getDocuments',
    value: function getDocuments() {
      var _this5 = this;

      var _state2 = this.state,
          repository = _state2.repository,
          name = _state2.name,
          version = _state2.version;


      if (repository && repository.host) {
        this.getRepositoryDetails(repository);
      }

      Object(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* get */])({
        url: 'https://bundlephobia.com/api/size?package=' + name + '@' + version,
        type: 'json',
        headers: {
          'X-Bundlephobia-User': 'yarn website'
        }
      }).then(function (res) {
        return _this5.setState({
          bundlesize: {
            href: 'https://bundlephobia.com/result?p=' + name + '@' + version,
            size: __WEBPACK_IMPORTED_MODULE_1_bytes___default()(res.size),
            gzip: __WEBPACK_IMPORTED_MODULE_1_bytes___default()(res.gzip)
          }
        });
      });
    }
  }, {
    key: 'maybeRenderReadme',
    value: function maybeRenderReadme() {
      if (this.state.loaded) {
        var _state3 = this.state,
            readmeLoading = _state3.readmeLoading,
            _state3$readme = _state3.readme,
            readme = _state3$readme === undefined ? '' : _state3$readme;

        if (readme.length === 0 || readme === readmeErrorMessage) {
          // Still loading
          if (readmeLoading) {
            return null;
          }
          return _jsx('div', {}, void 0, window.i18n.detail.no_readme_found);
        }
        return _jsx(__WEBPACK_IMPORTED_MODULE_4____["x" /* ReadMore */], {
          text: window.i18n.detail.display_full_readme,
          className: 'details-doc--content'
        }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4____["u" /* Markdown */], {
          source: this.state.readme,
          repository: this.state.repository
        }));
      } else {
        return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.state.isBrowsingFiles) {
        return this._renderFileBrowser();
      }
      if (this.state.objectDoesntExist) {
        return this._renderInvalidPackage();
      }
      return this._renderDetails();
    }
  }, {
    key: '_renderInvalidPackage',
    value: function _renderInvalidPackage() {
      return _jsx('section', {
        className: 'text-center d-flex flex-column'
      }, void 0, _jsx('h2', {
        className: 'details-main--title d-inline-block m-2'
      }, void 0, window.i18n.detail.not_found.whoa.replace('{package_name}', this.props.objectID)), _jsx('p', {}, void 0, window.i18n.detail.not_found.yours), _jsx('div', {
        className: 'text-left mx-auto'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4____["e" /* Copyable */], {
        pre: '$ '
      }, void 0, 'mkdir ', this.props.objectID), _jsx(__WEBPACK_IMPORTED_MODULE_4____["e" /* Copyable */], {
        pre: '$ '
      }, void 0, 'cd ', this.props.objectID), _ref9, _jsx('p', {
        className: 'text-center'
      }, void 0, window.i18n.detail.not_found.make), _ref10));
    }
  }, {
    key: '_renderDetails',
    value: function _renderDetails() {
      return _jsx('div', {
        className: 'details row'
      }, void 0, _jsx('section', {
        className: 'details-main col-lg-8'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4____["m" /* Header */], {
        name: this.state.name,
        owner: this.state.owner,
        downloadsLast30Days: this.state.downloadsLast30Days,
        humanDownloadsLast30Days: this.state.humanDownloadsLast30Days,
        description: this.state.description,
        license: this.state.license,
        deprecated: this.state.deprecated,
        keywords: this.state.keywords,
        version: this.state.version,
        types: this.state.types
      }), _jsx('section', {
        id: 'readme',
        className: 'details-doc'
      }, void 0, _jsx('h3', {
        className: 'details-doc--title details-doc--title__readme py-1'
      }, void 0, _jsx('a', {
        href: '#readme'
      }, void 0, window.i18n.detail.readme)), this.maybeRenderReadme()), this.state.changelog && _jsx('section', {
        id: 'changelog',
        className: 'details-doc'
      }, void 0, _jsx('h3', {
        className: 'details-doc--title details-doc--title__changelog py-1'
      }, void 0, _jsx('a', {
        href: '#changelog'
      }, void 0, window.i18n.detail.changelog)), _jsx(__WEBPACK_IMPORTED_MODULE_4____["x" /* ReadMore */], {
        text: window.i18n.detail.display_full_changelog,
        className: 'details-doc--content'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4____["u" /* Markdown */], {
        source: this.state.changelog,
        repository: this.state.repository
      })))), this._renderSidebar(), _jsx(__WEBPACK_IMPORTED_MODULE_4____["q" /* JSONLDItem */], {
        name: this.state.name,
        description: this.state.description,
        keywords: this.state.keywords
      }));
    }
  }, {
    key: '_renderSidebar',
    value: function _renderSidebar() {
      return _jsx(__WEBPACK_IMPORTED_MODULE_4____["b" /* Aside */], {
        name: this.state.name,
        repository: this.state.repository,
        homepage: this.state.homepage,
        contributors: this.state.owners,
        activity: this.state.activity,
        downloads: this.state.downloadsLast30Days,
        humanDownloads: this.state.humanDownloadsLast30Days,
        dependencies: this.state.dependencies,
        devDependencies: this.state.devDependencies,
        dependents: this.state.dependents,
        humanDependents: this.state.humanDependents,
        stargazers: this._getRepositoryStarCount(),
        versions: this.state.versions,
        version: this.state.version,
        tags: this.state.tags,
        bundlesize: this.state.bundlesize,
        onOpenFileBrowser: this._openFileBrowser,
        jsDelivrHits: this.state.jsDelivrHits
      });
    }
  }, {
    key: '_renderFileBrowser',
    value: function _renderFileBrowser() {
      return _jsx('div', {
        className: 'details row'
      }, void 0, _jsx('section', {
        className: 'details-main col-lg-8'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4____["k" /* FileBrowser */], {
        objectID: this.props.objectID,
        version: this.state.version,
        onBackToDetails: this._closeFileBrowser
      })), this._renderSidebar());
    }

    // Add/remove the 'files' param from the search (push to the history)

  }]);

  return Details;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),

/***/ "./components/Di.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Di; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var _ref2 = _jsx("span", {
  className: "dotted flex-grow"
});

var Di = function Di(_ref) {
  var icon = _ref.icon,
      title = _ref.title,
      description = _ref.description;
  return _jsx("div", {
    className: "d-flex justify-items-between w-100"
  }, void 0, icon && _jsx("img", {
    src: "/assets/detail/ico-" + icon + ".svg",
    alt: ""
  }), _jsx("dt", {}, void 0, title), _ref2, _jsx("dd", {}, void 0, description));
};

/***/ }),

/***/ "./components/Downloads.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Downloads; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./util/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var Downloads = function Downloads(_ref) {
  var _ref$downloads = _ref.downloads,
      downloads = _ref$downloads === undefined ? 0 : _ref$downloads,
      humanDownloads = _ref.humanDownloads;
  return _jsx('span', {
    className: 'ais-Hit-popular ' + Object(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* getDownloadBucket */])(downloads),
    title: window.i18n.downloads_in_last_30_days.replace('{count}', downloads.toLocaleString(window.i18n.active_language))
  }, void 0, humanDownloads);
};

/***/ }),

/***/ "./components/FileBrowser.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileBrowser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup__ = __webpack_require__("../../node_modules/react-transition-group/CSSTransitionGroup.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_unfetch__ = __webpack_require__("../../node_modules/unfetch/dist/unfetch.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bytes__ = __webpack_require__("../../node_modules/bytes/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bytes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bytes__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var SORT_ORDER = { directory: 1, file: 2 };

var FileBrowser = function (_React$PureComponent) {
  _inherits(FileBrowser, _React$PureComponent);

  function FileBrowser() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FileBrowser);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FileBrowser.__proto__ || Object.getPrototypeOf(FileBrowser)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      expandedDirs: {
        '/': true
      }
    }, _this._toggleDir = function (path) {
      _this.setState(function (_ref2) {
        var expandedDirs = _ref2.expandedDirs;
        return {
          expandedDirs: _extends({}, expandedDirs, _defineProperty({}, path, !expandedDirs[path]))
        };
      });
    }, _this._setBackRef = function (ref) {
      _this._backRef = ref;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FileBrowser, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._fetchFiles();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this._backRef) {
        this._backRef.focus();
      }
    }
  }, {
    key: '_fetchFiles',
    value: function _fetchFiles() {
      var _this2 = this;

      this.setState({ error: null, files: null });
      var url = this._getURLForPackageMetadata();
      Object(__WEBPACK_IMPORTED_MODULE_2_unfetch__["a" /* default */])(url).then(function (response) {
        // If status code >= 400 handle it as an error.
        if (!response.ok) {
          return response.json().then(function (body) {
            throw body;
          });
        }
        return response;
      }).then(function (response) {
        return response.json();
      }).then(function (files) {
        return _this2.setState({ files: files });
      }, function (error) {
        return _this2.setState({ error: error });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _jsx('div', {}, void 0, _jsx('h2', {
        className: 'm-2'
      }, void 0, window.i18n.detail.files_header.replace('{name}', this.props.objectID)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { href: '#', ref: this._setBackRef, onClick: this.props.onBackToDetails },
        '\u2190 ',
        window.i18n.detail.back_to_details
      ), this._renderInner());
    }
  }, {
    key: '_renderInner',
    value: function _renderInner() {
      if (this.state.files) {
        return _jsx(Directory, {
          name: '/',
          path: '/',
          baseURL: this._getBaseURL(),
          dir: this.state.files,
          expandedDirs: this.state.expandedDirs,
          onToggleDir: this._toggleDir
        });
      }
      if (this.state.error) {
        return _jsx('div', {
          className: 'alert alert-danger',
          role: 'alert'
        }, void 0, window.i18n.detail.files_error.replace('{error}', this.state.error.message));
      }
      return _jsx('div', {}, void 0, window.i18n.detail.loading);
    }
  }, {
    key: '_getBaseURL',
    value: function _getBaseURL() {
      return 'https://cdn.jsdelivr.net/npm/' + this.props.objectID + '@' + this.props.version;
    }
  }, {
    key: '_getURLForPackageMetadata',
    value: function _getURLForPackageMetadata() {
      return 'https://data.jsdelivr.com/v1/package/npm/' + this.props.objectID + '@' + this.props.version;
    }
  }]);

  return FileBrowser;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var Directory = function (_React$PureComponent2) {
  _inherits(Directory, _React$PureComponent2);

  function Directory() {
    var _ref3;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, Directory);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref3 = Directory.__proto__ || Object.getPrototypeOf(Directory)).call.apply(_ref3, [this].concat(args))), _this3), _this3._toggleDir = function (evt) {
      _this3.props.onToggleDir(_this3.props.path);
      evt.preventDefault();
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  }

  _createClass(Directory, [{
    key: 'render',
    value: function render() {
      var path = this.props.path;
      var url = this.props.baseURL + path;
      if (path === '/') {
        // Special case for root - Only render the contents, not the outer
        // wrapper.
        return this._renderDirContents();
      }
      return _jsx('li', {}, path, _jsx('a', {
        className: 'details-files__dirname',
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer',
        onClick: this._toggleDir
      }, void 0, this.props.name), _jsx(__WEBPACK_IMPORTED_MODULE_1_react_transition_group_CSSTransitionGroup___default.a, {
        transitionName: 'details-files',
        transitionEnterTimeout: 600,
        transitionLeaveTimeout: 600
      }, void 0, this._renderDirContents()));
    }
  }, {
    key: '_renderDirContents',
    value: function _renderDirContents() {
      var _this4 = this;

      if (!this.props.expandedDirs[this.props.path]) {
        return null;
      }
      var files = this.props.dir.files;

      files.sort(function (a, b) {
        // Sort by type (directories to the top)
        if (a.type !== b.type) {
          return SORT_ORDER[a.type] - SORT_ORDER[b.type];
        }
        // Then sort by filename, case insensitive
        return a.name.localeCompare(b.name, 'en', { sensitivity: 'base' });
      });

      return _jsx('ul', {
        className: 'details-files__list'
      }, void 0, files.map(function (file) {
        if (file.type === 'directory') {
          return _jsx(Directory, {
            baseURL: _this4.props.baseURL,
            dir: file,
            name: file.name,
            path: _this4.props.path + file.name + '/',
            expandedDirs: _this4.props.expandedDirs,
            onToggleDir: _this4.props.onToggleDir
          }, _this4.props.path + file.name);
        } else {
          return _jsx(File, {
            file: file,
            name: file.name,
            url: _this4.props.baseURL + _this4.props.path + file.name,
            size: file.size
          }, _this4.props.path + file.name);
        }
      }));
    }
  }]);

  return Directory;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

var File = function File(_ref4) {
  var file = _ref4.file,
      url = _ref4.url,
      key = _ref4.key,
      size = _ref4.size;
  return _jsx('li', {
    className: 'd-flex justify-items-between align-items-baseline'
  }, key, _jsx('a', {
    className: 'details-files__filename',
    href: url,
    target: '_blank'
  }, void 0, file.name), _jsx('small', {}, void 0, __WEBPACK_IMPORTED_MODULE_3_bytes___default()(size)));
};

/***/ }),

/***/ "./components/GithubActivity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GithubActivity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./util/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__("./components/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var threeMonths = 12; // 4 weeks * 3 = 12

var commitsLastThreeMonths = function commitsLastThreeMonths(_ref) {
  var weeklyData = _ref.weeklyData;
  return weeklyData.slice(-(threeMonths + 1));
};

var countCommitsLastThreeMonths = function countCommitsLastThreeMonths(_ref2) {
  var weeklyData = _ref2.weeklyData;
  return commitsLastThreeMonths({ weeklyData: weeklyData }).reduce(function (acc, _ref3) {
    var total = _ref3.total;
    return acc + total;
  }, 0);
};

var commitsPerWeekLastThreeMonths = function commitsPerWeekLastThreeMonths(_ref4) {
  var weeklyData = _ref4.weeklyData;
  return commitsLastThreeMonths({ weeklyData: weeklyData }).map(function (week) {
    return week.total;
  });
};

var weeksAgoSinceLastCommit = function weeksAgoSinceLastCommit(_ref5) {
  var weeklyData = _ref5.weeklyData;
  return formatWeeksSinceLastCommit(weeklyData.slice().reverse().findIndex(function (_ref6) {
    var total = _ref6.total;
    return total !== 0;
  }));
};

var formatWeeksSinceLastCommit = function formatWeeksSinceLastCommit(weeks) {
  if (weeks === -1) {
    return window.i18n.detail.over_a_year_ago;
  }
  if (weeks < 1) {
    return window.i18n.detail.less_than_a_week_ago;
  }
  if (weeks === 1) {
    return window.i18n.detail.one_week_ago;
  }
  return window.i18n.detail.weeks_ago.replace('{count}', weeks);
};

var GithubActivity = function GithubActivity(_ref7) {
  var _ref7$data = _ref7.data,
      data = _ref7$data === undefined ? [] : _ref7$data,
      repository = _ref7.repository;

  if (Object(__WEBPACK_IMPORTED_MODULE_1__util__["f" /* isEmpty */])(data)) {
    return null;
  }

  return _jsx(__WEBPACK_IMPORTED_MODULE_2____["a" /* Activity */], {
    lastCommit: weeksAgoSinceLastCommit({ weeklyData: data }),
    commitsLastThreeMonths: countCommitsLastThreeMonths({ weeklyData: data }),
    graphData: commitsPerWeekLastThreeMonths({ weeklyData: data }),
    graphLink: 'https://github.com/' + Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* encode */])(repository.user) + '/' + Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* encode */])(repository.project) + '/graphs/commit-activity'
  });
};

/***/ }),

/***/ "./components/Header.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Header; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("./components/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./util/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var Description = function Description(_ref) {
  var description = _ref.description,
      deprecated = _ref.deprecated;
  return _jsx('div', {}, void 0, deprecated ? _jsx('p', {
    className: 'm-2'
  }, void 0, _jsx('strong', {
    dangerouslySetInnerHTML: Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* safeMarkdown */])(deprecated)
  })) : null, _jsx('p', {
    className: 'm-2 lead',
    dangerouslySetInnerHTML: Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* safeMarkdown */])(description)
  }));
};

var Header = function Header(_ref2) {
  var name = _ref2.name,
      owner = _ref2.owner,
      downloadsLast30Days = _ref2.downloadsLast30Days,
      humanDownloadsLast30Days = _ref2.humanDownloadsLast30Days,
      description = _ref2.description,
      license = _ref2.license,
      deprecated = _ref2.deprecated,
      _ref2$keywords = _ref2.keywords,
      keywords = _ref2$keywords === undefined ? [] : _ref2$keywords,
      version = _ref2.version,
      types = _ref2.types;
  return _jsx('header', {
    className: 'details-main--header'
  }, void 0, _jsx('h2', {
    className: 'details-main--title d-inline-block m-2'
  }, void 0, name), _jsx('div', {
    className: 'details-main--info d-inline-block m-2'
  }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["v" /* Owner */], owner), _jsx(__WEBPACK_IMPORTED_MODULE_1____["j" /* Downloads */], {
    downloads: downloadsLast30Days,
    humanDownloads: humanDownloadsLast30Days
  }), _jsx(__WEBPACK_IMPORTED_MODULE_1____["s" /* License */], {
    type: license
  }), _jsx(__WEBPACK_IMPORTED_MODULE_1____["f" /* Deprecated */], {
    deprecated: deprecated
  }), _jsx('span', {
    className: 'ais-Hit-version'
  }, void 0, version), _jsx(__WEBPACK_IMPORTED_MODULE_1____["C" /* TypeScript */], {
    ts: types.ts
  })), _jsx(Description, {
    description: description,
    deprecated: deprecated
  }), _jsx(__WEBPACK_IMPORTED_MODULE_1____["r" /* Keywords */], {
    keywords: keywords,
    maxKeywords: keywords.length
  }));
};

/***/ }),

/***/ "./components/HighlightedMarkdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighlightedMarkdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__("../../node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./util/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





var HighlightedMarkdown = Object(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["i" /* connectHighlight */])(function (_ref) {
  var highlight = _ref.highlight,
      attribute = _ref.attribute,
      hit = _ref.hit;
  return _jsx('span', {
    className: 'ais-Hit-keyword'
  }, void 0, highlight({
    attribute: attribute,
    hit: hit,
    highlightProperty: '_highlightResult'
  }).map(function (v, i) {
    return v.isHighlighted ? _jsx('em', {
      className: 'ais-Highlight-highlighted',
      dangerouslySetInnerHTML: Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* safeMarkdown */])(v.value)
    }, 'split-' + i + '-' + v.value) : _jsx('span', {
      className: 'ais-Highlight-nonHighlighted',
      dangerouslySetInnerHTML: Object(__WEBPACK_IMPORTED_MODULE_2__util__["k" /* safeMarkdown */])(v.value)
    }, 'split-' + i + '-' + v.value);
  }));
});

/***/ }),

/***/ "./components/Hit.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_formatDistance__ = __webpack_require__("../../node_modules/date-fns/formatDistance/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_date_fns_formatDistance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_date_fns_formatDistance__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__ = __webpack_require__("../../node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./util/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__("./components/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







var Hit = function Hit(_ref) {
  var hit = _ref.hit,
      onTagClick = _ref.onTagClick,
      onOwnerClick = _ref.onOwnerClick;
  return _jsx('div', {
    className: 'ais-Hits-item'
  }, void 0, _jsx('a', {
    className: 'ais-Hit-name',
    href: Object(__WEBPACK_IMPORTED_MODULE_3__util__["i" /* packageLink */])(hit.name)
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_instantsearch_dom__["d" /* Highlight */], {
    attribute: 'name',
    hit: hit
  })), _jsx(__WEBPACK_IMPORTED_MODULE_4____["j" /* Downloads */], {
    downloads: hit.downloadsLast30Days,
    humanDownloads: hit.humanDownloadsLast30Days
  }), _jsx(__WEBPACK_IMPORTED_MODULE_4____["s" /* License */], {
    type: hit.license
  }), _jsx(__WEBPACK_IMPORTED_MODULE_4____["f" /* Deprecated */], {
    deprecated: hit.deprecated
  }), _jsx('span', {
    className: 'ais-Hit-version'
  }, void 0, hit.version), _jsx(__WEBPACK_IMPORTED_MODULE_4____["C" /* TypeScript */], {
    ts: hit.types.ts
  }), _jsx('p', {
    className: 'ais-Hit-description'
  }, void 0, hit.deprecated ? hit.deprecated : _jsx(__WEBPACK_IMPORTED_MODULE_4____["n" /* HighlightedMarkdown */], {
    attribute: 'description',
    hit: hit
  })), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["v" /* Owner */], _extends({}, hit.owner, { onClick: onOwnerClick })), _jsx('span', {
    className: 'ais-Hit-lastUpdate',
    title: window.i18n.last_updated.replace('{update_date}', new Date(hit.modified).toLocaleDateString(window.i18n.active_language))
  }, void 0, window.i18n.time_ago.replace('{time_distance}', __WEBPACK_IMPORTED_MODULE_1_date_fns_formatDistance___default()(new Date(hit.modified), new Date()))), Object(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* isEmpty */])(hit.keywords) ? null : _jsx('span', {
    className: 'ais-Hit-keywords hidden-sm-down'
  }, void 0, Object(__WEBPACK_IMPORTED_MODULE_3__util__["b" /* formatKeywords */])(hit.keywords, hit._highlightResult.keywords, 4, onTagClick)), _jsx(__WEBPACK_IMPORTED_MODULE_4____["t" /* Links */], {
    className: 'ais-Hit-links',
    name: hit.name,
    homepage: hit.homepage,
    repository: hit.repository
  }));
};

/***/ }),

/***/ "./components/Install.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Install; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("./components/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Install = function (_Component) {
  _inherits(Install, _Component);

  function Install() {
    _classCallCheck(this, Install);

    return _possibleConstructorReturn(this, (Install.__proto__ || Object.getPrototypeOf(Install)).apply(this, arguments));
  }

  _createClass(Install, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          onOpenFileBrowser = _props.onOpenFileBrowser;

      return _jsx('article', {
        className: 'details-side--copy'
      }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.use_it), _jsx(__WEBPACK_IMPORTED_MODULE_1____["e" /* Copyable */], {
        pre: '$ ',
        tag: 'code'
      }, void 0, 'yarn add ', name), _jsx('div', {}, void 0, _jsx('a', {
        className: 'details-side--runkit',
        href: 'https://runkit.com/npm/' + name,
        target: '_blank',
        rel: 'noopener noreferrer'
      }, void 0, window.i18n.detail.try_in_runkit), ' · ', _jsx('a', {
        href: '#',
        onClick: onOpenFileBrowser
      }, void 0, window.i18n.detail.browse_files)));
    }
  }]);

  return Install;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),

/***/ "./components/JSONLDItem.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JSONLDItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./util/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




/**
 * JSON-ld is a technology that allows crawlers to get info about
 * documents on the web, in a more structured way that microdata.
 *
 * Here we use schema.org's documents that describe a SoftwareApplication
 * of the type DeveloperApplication. It takes the description, name
 * url etc from this package data.
 *
 * Crawlers like Google can take this data and then display the Yarn
 * detail page however they want Software to look.
 *
 * At this point Google etc. doesn't display it separately yet, but since
 * both Yarn, npm and other sites include this information, they might
 * very well in the future.
 *
 * read more about it on: http://json-ld.org
 */

var JSONLDItem = function JSONLDItem(_ref) {
  var name = _ref.name,
      description = _ref.description,
      keywords = _ref.keywords;
  return _jsx('script', {
    type: 'application/ld+json'
  }, void 0, JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'SoftwareApplication',
    name: name,
    description: description,
    url: Object(__WEBPACK_IMPORTED_MODULE_1__util__["i" /* packageLink */])(name),
    keywords: keywords.join(','),
    applicationCategory: 'DeveloperApplication',
    offers: {
      '@type': 'Offer',
      price: '0.00'
    }
  }));
};

/***/ }),

/***/ "./components/Keywords.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Keywords; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./util/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var Keywords = function Keywords(_ref) {
  var _ref$keywords = _ref.keywords,
      keywords = _ref$keywords === undefined ? [] : _ref$keywords,
      _ref$maxKeywords = _ref.maxKeywords,
      maxKeywords = _ref$maxKeywords === undefined ? 4 : _ref$maxKeywords;

  return Object(__WEBPACK_IMPORTED_MODULE_1__util__["f" /* isEmpty */])(keywords) ? null : _jsx('span', {
    className: 'ais-Hit-keywords hidden-sm-down'
  }, void 0, keywords.slice(0, maxKeywords).map(function (keyword, i) {
    return _jsx('a', {
      href: Object(__WEBPACK_IMPORTED_MODULE_1__util__["l" /* searchLink */])({ keyword: keyword, query: ' ' })
    }, i, keyword);
  }).reduce(function (prev, curr, i) {
    return [prev, _jsx('span', {}, i + '-separator', ', '), curr];
  }));
};

/***/ }),

/***/ "./components/License.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return License; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var License = function License(_ref) {
  var type = _ref.type;
  return type ? _jsx("span", {
    className: "ais-Hit-license"
  }, void 0, type) : null;
};

/***/ }),

/***/ "./components/Links.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Links; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./util/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();




var Repository = function Repository(_ref) {
  var repository = _ref.repository,
      name = _ref.name;

  var _repository$host$spli = repository.host.split('.'),
      _repository$host$spli2 = _slicedToArray(_repository$host$spli, 1),
      provider = _repository$host$spli2[0];

  return _jsx('span', {
    className: 'ais-Hit-link-' + provider
  }, void 0, _jsx('a', {
    title: Object(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* i18nReplaceVars */])(window.i18n.repository_of, {
      provider: window.i18n[provider] || provider,
      name: name
    }),
    href: 'https://' + repository.host + '/' + Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* encode */])(repository.user) + '/' + Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* encode */])(repository.project) + (repository.path || '')
  }, void 0, window.i18n[provider]));
};

var Links = function Links(_ref2) {
  var name = _ref2.name,
      homepage = _ref2.homepage,
      repository = _ref2.repository,
      className = _ref2.className;
  return _jsx('div', {
    className: className
  }, void 0, _jsx('span', {
    className: 'ais-Hit-link-npm'
  }, void 0, _jsx('a', {
    href: 'https://www.npmjs.com/package/' + name,
    title: window.i18n.npm_page_for.replace('{name}', name)
  }, void 0, window.i18n.npm)), repository && Object(__WEBPACK_IMPORTED_MODULE_1__util__["g" /* isKnownRepositoryHost */])(repository.host) ? _jsx(Repository, {
    name: name,
    repository: repository
  }) : null, homepage ? _jsx('span', {
    className: 'ais-Hit-link-homepage'
  }, void 0, _jsx('a', {
    title: 'Homepage of ' + name,
    href: homepage
  }, void 0, window.i18n.homepage)) : null);
};

/***/ }),

/***/ "./components/Markdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Markdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked__ = __webpack_require__("../../node_modules/marked/lib/marked.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xss__ = __webpack_require__("../../node_modules/xss/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_highlight_pack__ = __webpack_require__("./util/highlight.pack.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_highlight_pack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_highlight_pack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__("./util/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








__WEBPACK_IMPORTED_MODULE_1_marked___default.a.Lexer.rules.gfm.heading = __WEBPACK_IMPORTED_MODULE_1_marked___default.a.Lexer.rules.normal.heading;
__WEBPACK_IMPORTED_MODULE_1_marked___default.a.Lexer.rules.tables.heading = __WEBPACK_IMPORTED_MODULE_1_marked___default.a.Lexer.rules.normal.heading;

var renderAndEscapeMarkdown = function renderAndEscapeMarkdown(_ref) {
  var source = _ref.source,
      repository = _ref.repository;

  var renderer = new __WEBPACK_IMPORTED_MODULE_1_marked___default.a.Renderer();

  if (repository && Object(__WEBPACK_IMPORTED_MODULE_4__util__["g" /* isKnownRepositoryHost */])(repository.host)) {

    // manually ask for sanitation of svgs, otherwise it will have wrong content-type
    var sanitizeSvg = function sanitizeSvg(href) {
      if (href.indexOf('//') === -1 && String.prototype.endsWith && href.endsWith('.svg')) {
        return href + '?sanitize=true';
      }
      return href;
    };

    var user = repository.user,
        project = repository.project,
        path = repository.path,
        head = repository.head,
        host = repository.host;


    var prefixImage = function prefixImage(href) {
      return host === 'github.com' ? Object(__WEBPACK_IMPORTED_MODULE_4__util__["j" /* prefixURL */])(href, {
        base: 'https://raw.githubusercontent.com',
        user: user,
        project: project,
        head: head || 'master',
        path: path
      }) : host === 'gitlab.com' ? Object(__WEBPACK_IMPORTED_MODULE_4__util__["j" /* prefixURL */])(href, {
        base: 'https://gitlab.com',
        user: user,
        project: project,
        head: 'raw/' + (head || 'master'),
        path: path ? path.replace('tree', 'raw') : ''
      }) : Object(__WEBPACK_IMPORTED_MODULE_4__util__["j" /* prefixURL */])(href, {
        base: 'https://bitbucket.org',
        user: user,
        project: project,
        head: 'raw/' + (head || 'master'),
        path: path ? path.replace('src', 'raw') : ''
      });
    };

    var prefixLink = function prefixLink(href) {
      return host === 'bitbucket.org' ? Object(__WEBPACK_IMPORTED_MODULE_4__util__["j" /* prefixURL */])(href, {
        base: 'https://bitbucket.org',
        user: user,
        project: project,
        head: 'src/' + (head || 'master'),
        path: path
      }) : Object(__WEBPACK_IMPORTED_MODULE_4__util__["j" /* prefixURL */])(href, {
        // Github and Gitlab are the same
        base: 'https://' + host,
        user: user,
        project: project,
        head: 'blob/' + (head || 'master'),
        path: path
      });
    };

    renderer.image = function (href, title, text) {
      return '<img src="' + prefixImage(sanitizeSvg(href)) + '" title="' + title + '" alt="' + text + '"/>';
    };

    renderer.link = function (href, title, text) {
      // No need to prefix hashes
      if (href.startsWith('#')) {
        return '<a href="' + href + '" title="' + title + '">' + text + '</a>';
      }
      // wrongly linked comments
      // see https://github.com/yarnpkg/website/issues/685
      if (text.startsWith('!--')) {
        return '';
      }
      return '<a href="' + prefixLink(href) + '" title="' + title + '">' + text + '</a>';
    };

    renderer.html = function (html) {
      return html.replace(/(src|href)="([^"]*)/g, function (match, type, href) {
        return type + '="' + (type === 'href' ? prefixLink(href) : prefixImage(sanitizeSvg(href)));
      });
    };
  }

  renderer.code = function (code, lang) {
    if (lang && __WEBPACK_IMPORTED_MODULE_3__util_highlight_pack___default.a.getLanguage(lang)) {
      try {
        var prepared = __WEBPACK_IMPORTED_MODULE_3__util_highlight_pack___default.a.highlight(lang, code);
        return '<pre><code class="' + prepared.language + '">' + prepared.value + '</code></pre>';
      } catch (err) {}
    }

    try {
      var _prepared = __WEBPACK_IMPORTED_MODULE_3__util_highlight_pack___default.a.highlightAuto(code);
      return '<pre><code class="' + _prepared.language + '">' + _prepared.value + '</code></pre>';
    } catch (err) {}

    return '<pre><code>' + code + '</code></pre>';
  };

  return __WEBPACK_IMPORTED_MODULE_2_xss___default()(__WEBPACK_IMPORTED_MODULE_1_marked___default()(source, { renderer: renderer, mangle: false }), {
    whiteList: _extends({}, __WEBPACK_IMPORTED_MODULE_2_xss___default.a.getDefaultWhiteList(), {
      code: ['class'],
      span: ['class'],
      h1: ['id'],
      h2: ['id'],
      h3: ['id'],
      h4: ['id'],
      h5: ['id'],
      h6: ['id']
    })
  });
};

var Markdown = function Markdown(_ref2) {
  var source = _ref2.source,
      repository = _ref2.repository;
  return _jsx('article', {
    dangerouslySetInnerHTML: {
      __html: renderAndEscapeMarkdown({
        source: source,
        repository: repository
      })
    }
  });
};

/***/ }),

/***/ "./components/Owner.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Owner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var Owner = function Owner(_ref) {
  var link = _ref.link,
      avatar = _ref.avatar,
      name = _ref.name,
      _onClick = _ref.onClick;
  return _jsx("a", {
    className: "ais-Hit-ownerLink",
    href: link,
    onClick: function onClick(e) {
      if (_onClick && !(e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        _onClick(name);
      }
    }
  }, void 0, _jsx("img", {
    width: "20",
    height: "20",
    className: "ais-Hit-ownerAvatar",
    alt: "",
    src: "https://res.cloudinary.com/hilnmyskv/image/fetch/w_40,h_40,f_auto,q_80,fl_lossy/" + avatar
  }), name);
};

/***/ }),

/***/ "./components/Popularity.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Popularity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("./components/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__("./util/index.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Stargazers = function Stargazers(_ref) {
  var stargazers = _ref.stargazers,
      repository = _ref.repository;

  if (stargazers < 0 || !repository || !Object(__WEBPACK_IMPORTED_MODULE_2__util__["g" /* isKnownRepositoryHost */])(repository.host)) {
    return null;
  }

  var _repository$host$spli = repository.host.split('.'),
      _repository$host$spli2 = _slicedToArray(_repository$host$spli, 1),
      provider = _repository$host$spli2[0];

  return _jsx(__WEBPACK_IMPORTED_MODULE_1____["i" /* Di */], {
    icon: 'stargazers',
    title: window.i18n.detail[provider + '_stargazers'],
    description: stargazers.toLocaleString(window.i18n.active_language)
  });
};

var Downloads = function Downloads(_ref2) {
  var downloads = _ref2.downloads,
      humanDownloads = _ref2.humanDownloads;
  return downloads >= 0 && humanDownloads && _jsx(__WEBPACK_IMPORTED_MODULE_1____["i" /* Di */], {
    icon: 'downloads',
    title: window.i18n.detail.downloads_last_30_days,
    description: _jsx('span', {
      title: downloads.toLocaleString(window.i18n.active_language)
    }, void 0, humanDownloads)
  });
};

var Dependents = function Dependents(_ref3) {
  var dependents = _ref3.dependents,
      humanDependents = _ref3.humanDependents,
      name = _ref3.name;
  return dependents >= 0 && _jsx(__WEBPACK_IMPORTED_MODULE_1____["i" /* Di */], {
    icon: 'dependents',
    title: window.i18n.detail.dependents,
    description: _jsx('a', {
      href: 'https://www.npmjs.com/browse/depended/' + name,
      target: '_blank',
      rel: 'noopener noreferrer',
      title: dependents.toLocaleString(window.i18n.active_language)
    }, void 0, humanDependents)
  });
};

var formatHits = function formatHits(hits) {
  if (hits >= 1e9) {
    return Math.round(hits / 1e7) / 100 + 'b';
  } else if (hits >= 1e6) {
    return Math.round(hits / 1e4) / 100 + 'm';
  } else if (hits >= 1000) {
    return Math.round(hits / 10) / 100 + 'k';
  }

  return hits;
};

var JsDelivrHits = function JsDelivrHits(_ref4) {
  var jsDelivrHits = _ref4.jsDelivrHits;
  return _jsx(__WEBPACK_IMPORTED_MODULE_1____["i" /* Di */], {
    icon: 'downloads',
    title: window.i18n.detail.jsdelivr_hits,
    description: _jsx('span', {
      title: jsDelivrHits.toLocaleString(window.i18n.active_language)
    }, void 0, formatHits(jsDelivrHits))
  });
};

var Popularity = function (_Component) {
  _inherits(Popularity, _Component);

  function Popularity() {
    _classCallCheck(this, Popularity);

    return _possibleConstructorReturn(this, (Popularity.__proto__ || Object.getPrototypeOf(Popularity)).apply(this, arguments));
  }

  _createClass(Popularity, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          name = _props.name,
          stargazers = _props.stargazers,
          repository = _props.repository,
          downloads = _props.downloads,
          humanDownloads = _props.humanDownloads,
          dependents = _props.dependents,
          humanDependents = _props.humanDependents,
          jsDelivrHits = _props.jsDelivrHits;


      if (downloads >= 0 || dependents >= 0 || stargazers >= 0 || jsDelivrHits >= 0) {
        return _jsx('article', {
          className: 'details-side--popularity'
        }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.popularity), _jsx('dl', {}, void 0, _jsx(Stargazers, {
          repository: repository,
          stargazers: stargazers
        }), _jsx(Downloads, {
          downloads: downloads,
          humanDownloads: humanDownloads
        }), _jsx(JsDelivrHits, {
          jsDelivrHits: jsDelivrHits
        }), _jsx(Dependents, {
          dependents: dependents,
          humanDependents: humanDependents,
          name: name
        })));
      }
      return null;
    }
  }]);

  return Popularity;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),

/***/ "./components/ReadMore.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReadMore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var ReadMore = function (_Component) {
  _inherits(ReadMore, _Component);

  function ReadMore(props) {
    _classCallCheck(this, ReadMore);

    var _this = _possibleConstructorReturn(this, (ReadMore.__proto__ || Object.getPrototypeOf(ReadMore)).call(this, props));

    _this.toggleCollapse = function () {
      _this.setState({
        collapsed: !_this.state.collapsed
      });
    };

    _this.maxHeight = props.height + 'px';
    _this.state = {
      collapsed: true,
      collapsible: true
    };
    return _this;
  }

  _createClass(ReadMore, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      var _content$getBoundingC = this.content.getBoundingClientRect(),
          height = _content$getBoundingC.height;

      if (nextState.collapsible && height < nextProps.height) {
        this.setState({
          collapsible: false,
          collapsed: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          text = _props.text,
          className = _props.className;
      var _state = this.state,
          collapsed = _state.collapsed,
          collapsible = _state.collapsible;


      return _jsx('div', {
        className: className + ' readMore ' + (collapsed ? 'readMore--collapsed' : '')
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        {
          className: 'readMore--content',
          style: { maxHeight: collapsed ? this.maxHeight : '' },
          ref: function ref(div) {
            return _this2.content = div;
          }
        },
        children
      ), collapsible && _jsx('button', {
        className: 'readMore--button',
        onClick: this.toggleCollapse
      }, void 0, collapsed ? text : window.i18n.detail.collapse, _jsx('img', {
        src: '/assets/detail/ico-readmore.svg',
        alt: '',
        className: 'readMore--icon',
        style: { transform: collapsed ? '' : 'rotate(180deg)' }
      })));
    }
  }]);

  return ReadMore;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ReadMore.defaultProps = {
  height: 250,
  className: ''
};

/***/ }),

/***/ "./components/Results.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Results; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__("../../node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__("./components/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("./util/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();







var body = document.querySelector('body');

var Hits = Object(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["j" /* connectHits */])(function (_ref) {
  var hits = _ref.hits,
      onTagClick = _ref.onTagClick,
      onOwnerClick = _ref.onOwnerClick;
  return hits.map(function (hit) {
    return _jsx(__WEBPACK_IMPORTED_MODULE_2____["o" /* Hit */], {
      onTagClick: onTagClick,
      onOwnerClick: onOwnerClick,
      hit: hit
    }, hit.objectID);
  });
});

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["b" /* CurrentRefinements */], {});

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["f" /* Pagination */], {
  showFirst: false,
  showLast: false,
  scrollTo: true
});

var ResultsFound = function ResultsFound(_ref2) {
  var pagination = _ref2.pagination,
      onTagClick = _ref2.onTagClick,
      onOwnerClick = _ref2.onOwnerClick;
  return _jsx('div', {
    className: 'container'
  }, void 0, _jsx('div', {
    className: 'm-3'
  }, void 0, _ref3, _jsx(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["h" /* Stats */], {
    translations: {
      stats: function stats(num, time) {
        return window.i18n.result_stats.replace('{number_packages}', num.toLocaleString(window.i18n.active_language)).replace('{time_search}', time);
      }
    }
  })), _jsx(Hits, {
    onTagClick: onTagClick,
    onOwnerClick: onOwnerClick
  }), _jsx('div', {
    className: 'd-flex'
  }, void 0, pagination ? _ref4 : _jsx('div', {
    style: { height: '3rem' }
  })), _jsx('div', {
    className: 'search-footer'
  }, void 0, window.i18n.search_by_algolia, ' - ', _jsx('a', {
    href: 'https://discourse.algolia.com/t/2016-algolia-community-gift-yarn-package-search/319'
  }, void 0, window.i18n.search_by_read_more), '.'));
};

var connectResults = Object(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["l" /* createConnector */])({
  displayName: 'ConnectResults',
  getProvidedProps: function getProvidedProps(props, searchState, searchResults) {
    var pagination = searchResults.results ? searchResults.results.nbPages > 1 : false;
    var noResults = searchResults.results ? searchResults.results.nbHits === 0 : false;
    return { query: searchState.query, noResults: noResults, pagination: pagination };
  }
});

var _ref6 = _jsx('span', {});

var Results = connectResults(function (_ref5) {
  var noResults = _ref5.noResults,
      query = _ref5.query,
      pagination = _ref5.pagination,
      onTagClick = _ref5.onTagClick,
      onOwnerClick = _ref5.onOwnerClick;

  if (Object(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* isEmpty */])(query)) {
    body.classList.remove('searching');
    return _ref6;
  } else if (noResults) {
    body.classList.add('searching');
    var docMessage = window.i18n.no_results_docsearch.split(/[{}]+/);
    docMessage[docMessage.indexOf('documentation_link')] = _jsx('a', {
      href: window.i18n.url_base + '/docs'
    }, void 0, window.i18n.documentation);

    return _jsx('div', {
      className: 'container text-center mt-5'
    }, void 0, _jsx('p', {}, void 0, window.i18n.no_package_found.replace('{name}', query)), _jsx('p', {}, void 0, docMessage.map(function (val, index) {
      return _jsx('span', {}, index, val);
    })));
  } else {
    body.classList.add('searching');
    return _jsx(ResultsFound, {
      pagination: pagination,
      onTagClick: onTagClick,
      onOwnerClick: onOwnerClick
    });
  }
});

/***/ }),

/***/ "./components/Search.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Search; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__("../../node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__("./components/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_withUrlSync__ = __webpack_require__("./util/withUrlSync.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_config__ = __webpack_require__("./util/config.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var equals = function equals(arr1, arr2) {
  return arr1.length === arr2.length && arr1.reduce(function (a, b, i) {
    return a && arr2[i];
  }, true);
};

// package overview page
// home page (/:lang/)
var shouldFocus = function shouldFocus(path) {
  return path.includes('/packages') || path.replace(/\/[a-zA-Z\-]+\/?/, '').length === 0;
};

var FakeRefinementList = function (_Component) {
  _inherits(FakeRefinementList, _Component);

  function FakeRefinementList() {
    _classCallCheck(this, FakeRefinementList);

    return _possibleConstructorReturn(this, (FakeRefinementList.__proto__ || Object.getPrototypeOf(FakeRefinementList)).apply(this, arguments));
  }

  _createClass(FakeRefinementList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var currentRefinement = newProps.currentRefinement,
          defaultRefinement = newProps.defaultRefinement,
          onRefine = newProps.onRefine,
          refine = newProps.refine;
      var _props = this.props,
          oldCurrentRefinement = _props.currentRefinement,
          oldDefaultRefinement = _props.defaultRefinement;


      if (!equals(currentRefinement, oldCurrentRefinement)) {
        refine(currentRefinement);
        onRefine(currentRefinement);
      }

      if (!equals(defaultRefinement, oldDefaultRefinement)) {
        refine(defaultRefinement);
        onRefine(defaultRefinement);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return FakeRefinementList;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var VirtualRefinementList = Object(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["k" /* connectRefinementList */])(FakeRefinementList);

var RawSearch = function (_Component2) {
  _inherits(RawSearch, _Component2);

  function RawSearch(props) {
    _classCallCheck(this, RawSearch);

    var _this2 = _possibleConstructorReturn(this, (RawSearch.__proto__ || Object.getPrototypeOf(RawSearch)).call(this, props));

    _this2.addTag = function (newTag) {
      return _this2.setState(function (_ref) {
        var tags = _ref.tags;
        return { tags: tags.add(newTag) };
      });
    };

    _this2.addOwner = function (newOwner) {
      return _this2.setState(function (_ref2) {
        var owners = _ref2.owners;
        return { owners: owners.add(newOwner) };
      });
    };

    _this2.refineTag = function (newTags) {
      return _this2.setState(function () {
        return { tags: new Set(newTags) };
      });
    };

    _this2.refineOwner = function (newOwners) {
      return _this2.setState(function () {
        return { owners: new Set(newOwners) };
      });
    };

    _this2.state = { tags: new Set(), owners: new Set() };
    return _this2;
  }

  _createClass(RawSearch, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          searchState = _props2.searchState,
          onSearchStateChange = _props2.onSearchStateChange;


      return _jsx(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["e" /* InstantSearch */], {
        searchClient: __WEBPACK_IMPORTED_MODULE_4__util_config__["b" /* client */],
        indexName: __WEBPACK_IMPORTED_MODULE_4__util_config__["a" /* algolia */].indexName,
        searchState: searchState,
        onSearchStateChange: onSearchStateChange
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["a" /* Configure */], {
        hitsPerPage: 5,
        facets: ['keywords'],
        analyticsTags: ['yarnpkg.com'],
        attributesToRetrieve: ['deprecated', 'description', 'downloadsLast30Days', 'repository', 'homepage', 'humanDownloadsLast30Days', 'keywords', 'license', 'modified', 'name', 'owner', 'version', 'types'],
        attributesToHighlight: ['name', 'description', 'keywords']
      }), _jsx(__WEBPACK_IMPORTED_MODULE_2____["A" /* SearchBox */], {
        autoFocus: shouldFocus(window.location.pathname),
        translations: {
          placeholder: window.i18n.search_placeholder
        }
      }), _jsx(VirtualRefinementList, {
        attribute: 'keywords',
        defaultRefinement: [].concat(_toConsumableArray(this.state.tags)),
        onRefine: this.refineTag
      }), _jsx(VirtualRefinementList, {
        attribute: 'owner.name',
        defaultRefinement: [].concat(_toConsumableArray(this.state.owners)),
        onRefine: this.refineOwner
      }), _jsx(__WEBPACK_IMPORTED_MODULE_2____["y" /* Results */], {
        onTagClick: this.addTag,
        onOwnerClick: this.addOwner
      }));
    }
  }]);

  return RawSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var Search = Object(__WEBPACK_IMPORTED_MODULE_3__util_withUrlSync__["a" /* default */])(RawSearch);

/***/ }),

/***/ "./components/SearchBox.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchBox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__("../../node_modules/react-instantsearch-dom/dist/es/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var SearchBox = function (_Component) {
  _inherits(SearchBox, _Component);

  function SearchBox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SearchBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchBox.__proto__ || Object.getPrototypeOf(SearchBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleFocus = function () {
      return _this.setState({
        active: true
      });
    }, _this.handleBlur = function () {
      return _this.setState({
        active: false
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SearchBox, [{
    key: 'render',
    value: function render() {
      return _jsx('div', {
        className: 'full-searchbox ' + (this.state.active ? 'active' : '')
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["g" /* SearchBox */], _extends({
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, this.props)));
    }
  }]);

  return SearchBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),

/***/ "./components/Tags.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("./components/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();




var Tags = function Tags(_ref) {
  var tags = _ref.tags,
      name = _ref.name;

  var tagNames = Object.keys(tags);
  if (tagNames.length === 0) {
    return null;
  }

  return _jsx('article', {
    className: 'details-side--tags'
  }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.tags), _jsx('dl', {}, void 0, tagNames.map(function (tag) {
    return _jsx(__WEBPACK_IMPORTED_MODULE_1____["i" /* Di */], {
      title: _jsx('code', {}, void 0, tag),
      description: tags[tag]
    }, tag);
  })));
};

/***/ }),

/***/ "./components/TypeScript.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TypeScript; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();



var TypeScript = function TypeScript(_ref) {
  var _ref$ts = _ref.ts,
      ts = _ref$ts === undefined ? false : _ref$ts;

  return ts !== false ? _jsx("img", {
    className: "ais-Hit-typescript",
    src: "/assets/search/ico-typescript.svg",
    alt: "TypeScript support: " + ts,
    title: "TypeScript support: " + ts
  }) : null;
};

/***/ }),

/***/ "./components/Usage.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Usage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("./util/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__("./components/index.js");
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();






var deps = function deps(_ref) {
  var dependencies = _ref.dependencies,
      title = _ref.title;

  if (dependencies) {
    var dependencyNames = Object.keys(dependencies);

    return {
      title: dependencyNames.length > 0 ? _jsx('details', {}, void 0, _jsx('summary', {}, void 0, title), dependencyNames.map(function (name, index) {
        return _jsx('a', {
          href: Object(__WEBPACK_IMPORTED_MODULE_1__util__["i" /* packageLink */])(name),
          title: name + '@' + dependencies[name]
        }, index, name);
      }).reduce(function (prev, curr) {
        return [prev, ', ', curr];
      })) : title,
      description: dependencyNames.length
    };
  }
  return {};
};

var Usage = function Usage(_ref2) {
  var dependencies = _ref2.dependencies,
      devDependencies = _ref2.devDependencies,
      versions = _ref2.versions,
      bundlesize = _ref2.bundlesize,
      packageJSONLink = _ref2.packageJSONLink;
  return _jsx('article', {
    className: 'details-side--usage'
  }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.usage), _jsx('dl', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["i" /* Di */], _extends({
    icon: 'dependencies'
  }, deps({
    title: window.i18n.detail.dependencies,
    dependencies: dependencies
  }))), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2____["i" /* Di */], _extends({
    icon: 'devdependencies'
  }, deps({
    title: window.i18n.detail.devdependencies,
    dependencies: devDependencies
  }))), packageJSONLink && _jsx(__WEBPACK_IMPORTED_MODULE_2____["i" /* Di */], {
    icon: 'package-json',
    title: window.i18n.detail.packages,
    description: _jsx('a', {
      target: '_blank',
      rel: 'noopener noreferrer',
      href: packageJSONLink
    }, void 0, window.i18n.detail.see_package_json)
  }), bundlesize && _jsx(__WEBPACK_IMPORTED_MODULE_2____["i" /* Di */], {
    icon: 'download-size',
    title: window.i18n.detail.bundlesize,
    description: _jsx('a', {
      target: '_blank',
      rel: 'noopener noreferrer',
      href: bundlesize.href,
      title: window.i18n.detail.bundlesize_text.replace('{size}', bundlesize.size).replace('{gzip}', bundlesize.gzip)
    }, void 0, bundlesize.size)
  })));
};

/***/ }),

/***/ "./components/Versions.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Versions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__("./components/index.js");
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _localeVersion = function _localeVersion(pubDate) {
  return new Date(pubDate).toLocaleDateString(window.i18n.active_language, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

var Versions = function (_Component) {
  _inherits(Versions, _Component);

  function Versions(props) {
    _classCallCheck(this, Versions);

    var _this = _possibleConstructorReturn(this, (Versions.__proto__ || Object.getPrototypeOf(Versions)).call(this, props));

    _this.state = {
      isShowingMore: false
    };
    return _this;
  }

  _createClass(Versions, [{
    key: '_toggleShowMore',
    value: function _toggleShowMore() {
      this.setState(function (_ref) {
        var isShowingMore = _ref.isShowingMore;
        return {
          isShowingMore: !isShowingMore
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var versions = this.props.versions;
      var isShowingMore = this.state.isShowingMore;

      var versionKeys = Object.keys(versions);
      var buttonText = isShowingMore ? window.i18n.detail.hide : window.i18n.detail.display_all;
      var versionsToShow = isShowingMore ? versionKeys.reverse() : versionKeys.reverse().slice(0, 3);

      return _jsx('article', {
        className: 'details-side--versions'
      }, void 0, _jsx('h1', {}, void 0, window.i18n.detail.versions), _jsx('dl', {}, void 0, versionsToShow.map(function (version) {
        return _jsx(__WEBPACK_IMPORTED_MODULE_1____["i" /* Di */], {
          title: _localeVersion(versions[version]),
          description: version
        }, version);
      })), versionKeys.length > 3 && _jsx('button', {
        onClick: function onClick() {
          return _this2._toggleShowMore();
        },
        className: 'readMore--button'
      }, void 0, buttonText, _jsx('img', {
        src: '/assets/detail/ico-readmore.svg',
        alt: '',
        className: 'readMore--icon',
        style: { transform: isShowingMore ? 'rotate(180deg)' : '' }
      })));
    }
  }]);

  return Versions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),

/***/ "./components/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Activity_js__ = __webpack_require__("./components/Activity.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Activity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Aside_js__ = __webpack_require__("./components/Aside.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Aside_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cdn_js__ = __webpack_require__("./components/Cdn.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Cdn_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Contributors_js__ = __webpack_require__("./components/Contributors.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Contributors_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Copyable_js__ = __webpack_require__("./components/Copyable.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__Copyable_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Deprecated_js__ = __webpack_require__("./components/Deprecated.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__Deprecated_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DetailLinks_js__ = __webpack_require__("./components/DetailLinks.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__DetailLinks_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Details_js__ = __webpack_require__("./components/Details.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__Details_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Di_js__ = __webpack_require__("./components/Di.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_8__Di_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Downloads_js__ = __webpack_require__("./components/Downloads.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_9__Downloads_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FileBrowser_js__ = __webpack_require__("./components/FileBrowser.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_10__FileBrowser_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GithubActivity_js__ = __webpack_require__("./components/GithubActivity.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__GithubActivity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Header_js__ = __webpack_require__("./components/Header.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_12__Header_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HighlightedMarkdown_js__ = __webpack_require__("./components/HighlightedMarkdown.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_13__HighlightedMarkdown_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Hit_js__ = __webpack_require__("./components/Hit.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_14__Hit_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Install_js__ = __webpack_require__("./components/Install.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_15__Install_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__JSONLDItem_js__ = __webpack_require__("./components/JSONLDItem.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_16__JSONLDItem_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Keywords_js__ = __webpack_require__("./components/Keywords.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_17__Keywords_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__License_js__ = __webpack_require__("./components/License.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_18__License_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Links_js__ = __webpack_require__("./components/Links.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_19__Links_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Markdown_js__ = __webpack_require__("./components/Markdown.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_20__Markdown_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Owner_js__ = __webpack_require__("./components/Owner.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_21__Owner_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Popularity_js__ = __webpack_require__("./components/Popularity.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_22__Popularity_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ReadMore_js__ = __webpack_require__("./components/ReadMore.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_23__ReadMore_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Results_js__ = __webpack_require__("./components/Results.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_24__Results_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Search_js__ = __webpack_require__("./components/Search.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_25__Search_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__SearchBox_js__ = __webpack_require__("./components/SearchBox.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_26__SearchBox_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Tags_js__ = __webpack_require__("./components/Tags.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_27__Tags_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__TypeScript_js__ = __webpack_require__("./components/TypeScript.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_28__TypeScript_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Usage_js__ = __webpack_require__("./components/Usage.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_29__Usage_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Versions_js__ = __webpack_require__("./components/Versions.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_30__Versions_js__["a"]; });
































/***/ }),

/***/ "./util/config.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return algolia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return client; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return docsearch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_algoliasearch_lite__ = __webpack_require__("../../node_modules/algoliasearch/src/browser/builds/algoliasearchLite.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_algoliasearch_lite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_algoliasearch_lite__);


var algolia = {
  appId: 'OFCNCOG2CU',
  apiKey: 'f54e21fa3a2a0160595bb058179bfb1e',
  indexName: 'npm-search'
};

var client = __WEBPACK_IMPORTED_MODULE_0_algoliasearch_lite___default()(algolia.appId, algolia.apiKey, {
  _useRequestCache: true
});

var docsearch = {
  apiKey: '3949f721e5d8ca1de8928152ff745b28',
  indexName: 'yarnpkg'
};

/***/ }),

/***/ "./util/formatKeywords.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatKeywords; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__ = __webpack_require__("../../node_modules/react-instantsearch-dom/dist/es/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__("./util/index.js");


var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();





function formatKeywords() {
  var keywords = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var highlightedKeywords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var maxKeywords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;
  var _onClick = arguments[3];

  if (Object(__WEBPACK_IMPORTED_MODULE_2____["f" /* isEmpty */])(keywords)) return keywords;
  highlightedKeywords.forEach(function (el, i) {
    el.originalValue = keywords[i];
  });
  return highlightedKeywords.sort(function (k1, k2) {
    // sort keywords by match level
    if (k1.matchLevel !== k2.matchLevel) {
      if (k1.matchLevel === 'full') return -1;
      if (k2.matchLevel === 'full') return 1;
      return k1.matchLevel === 'partial' ? -1 : 1;
    }
    if (k1.matchedWords.length !== k2.matchedWords.length) {
      return k2.matchedWords.length - k1.matchedWords.length;
    }
    if (k1.matchedWords.join('').length !== k2.matchedWords.join('').length) {
      return k2.matchedWords.join('').length - k1.matchedWords.join('').length;
    }
    return 0;
  }).slice(0, maxKeywords).map(function (_ref, keywordIndex) {
    var highlightedKeyword = _ref.value,
        keyword = _ref.originalValue;

    var highlighted = parseHighlightedAttribute({
      highlightedValue: highlightedKeyword
    });
    var content = highlighted.map(function (v, i) {
      var key = 'split-' + i + '-' + v.value;
      if (v.isHighlighted) {
        return _jsx('em', {
          className: 'ais-Highlight-highlighted'
        }, key, v.value);
      }
      return _jsx('span', {
        className: 'ais-Highlight-nonHighlighted'
      }, key, v.value);
    });
    return _jsx('span', {
      className: 'ais-Hit-keyword',
      onClick: function onClick() {
        return _onClick(keyword);
      }
    }, '' + keyword + keywordIndex, content);
  }).reduce(function (prev, curr) {
    return [prev, ', ', curr];
  });
}

function parseHighlightedAttribute(_ref2) {
  var _ref2$preTag = _ref2.preTag,
      preTag = _ref2$preTag === undefined ? __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["c" /* HIGHLIGHT_TAGS */].highlightPreTag : _ref2$preTag,
      _ref2$postTag = _ref2.postTag,
      postTag = _ref2$postTag === undefined ? __WEBPACK_IMPORTED_MODULE_1_react_instantsearch_dom__["c" /* HIGHLIGHT_TAGS */].highlightPostTag : _ref2$postTag,
      highlightedValue = _ref2.highlightedValue;

  var splitByPreTag = highlightedValue.split(preTag);
  var firstValue = splitByPreTag.shift();
  var elements = firstValue === '' ? [] : [{ value: firstValue, isHighlighted: false }];

  if (postTag === preTag) {
    var isHighlighted = true;
    splitByPreTag.forEach(function (split) {
      elements.push({ value: split, isHighlighted: isHighlighted });
      isHighlighted = !isHighlighted;
    });
  } else {
    splitByPreTag.forEach(function (split) {
      var splitByPostTag = split.split(postTag);
      elements.push({
        value: splitByPostTag[0],
        isHighlighted: true
      });

      if (splitByPostTag[1] !== '') {
        elements.push({
          value: splitByPostTag[1],
          isHighlighted: false
        });
      }
    });
  }

  return elements;
}

/***/ }),

/***/ "./util/highlight.pack.js":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! highlight.js v9.12.0 | BSD3 License | git.io/hljslicense */
!function (e) {
  var t = 'object' == (typeof window === 'undefined' ? 'undefined' : _typeof(window)) && window || 'object' == (typeof self === 'undefined' ? 'undefined' : _typeof(self)) && self;
   true ? e(exports) : t && (t.hljs = e({}), 'function' == typeof define && define.amd && define([], function () {
    return t.hljs;
  }));
}(function (e) {
  function t(e) {
    return e.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  function r(e) {
    return e.nodeName.toLowerCase();
  }
  function n(e, t) {
    var r = e && e.exec(t);
    return r && 0 === r.index;
  }
  function a(e) {
    return M.test(e);
  }
  function i(e) {
    var t,
        r,
        n,
        i,
        o = e.className + ' ';
    if (o += e.parentNode ? e.parentNode.className : '', r = R.exec(o)) return N(r[1]) ? r[1] : 'no-highlight';
    for (o = o.split(/\s+/), t = 0, n = o.length; n > t; t++) {
      if (i = o[t], a(i) || N(i)) return i;
    }
  }
  function o(e) {
    var t,
        r = {},
        n = Array.prototype.slice.call(arguments, 1);
    for (t in e) {
      r[t] = e[t];
    }return n.forEach(function (e) {
      for (t in e) {
        r[t] = e[t];
      }
    }), r;
  }
  function s(e) {
    var t = [];
    return function n(e, a) {
      for (var i = e.firstChild; i; i = i.nextSibling) {
        3 === i.nodeType ? a += i.nodeValue.length : 1 === i.nodeType && (t.push({ event: 'start', offset: a, node: i }), a = n(i, a), r(i).match(/br|hr|img|input/) || t.push({ event: 'stop', offset: a, node: i }));
      }return a;
    }(e, 0), t;
  }
  function c(e, n, a) {
    function i() {
      return e.length && n.length ? e[0].offset !== n[0].offset ? e[0].offset < n[0].offset ? e : n : 'start' === n[0].event ? e : n : e.length ? e : n;
    }
    function o(e) {
      function n(e) {
        return ' ' + e.nodeName + '="' + t(e.value).replace('"', '&quot;') + '"';
      }
      u += '<' + r(e) + k.map.call(e.attributes, n).join('') + '>';
    }
    function s(e) {
      u += '</' + r(e) + '>';
    }
    function c(e) {
      ('start' === e.event ? o : s)(e.node);
    }
    for (var l = 0, u = '', b = []; e.length || n.length;) {
      var d = i();
      if (u += t(a.substring(l, d[0].offset)), l = d[0].offset, d === e) {
        b.reverse().forEach(s);
        do {
          c(d.splice(0, 1)[0]), d = i();
        } while (d === e && d.length && d[0].offset === l);
        b.reverse().forEach(o);
      } else 'start' === d[0].event ? b.push(d[0].node) : b.pop(), c(d.splice(0, 1)[0]);
    }
    return u + t(a.substr(l));
  }
  function l(e) {
    return e.v && !e.cached_variants && (e.cached_variants = e.v.map(function (t) {
      return o(e, { v: null }, t);
    })), e.cached_variants || e.eW && [o(e)] || [e];
  }
  function u(e) {
    function t(e) {
      return e && e.source || e;
    }
    function r(r, n) {
      return new RegExp(t(r), 'm' + (e.cI ? 'i' : '') + (n ? 'g' : ''));
    }
    function n(a, i) {
      if (!a.compiled) {
        if (a.compiled = !0, a.k = a.k || a.bK, a.k) {
          var o = {},
              s = function s(t, r) {
            e.cI && (r = r.toLowerCase()), r.split(' ').forEach(function (e) {
              var r = e.split('|');
              o[r[0]] = [t, r[1] ? Number(r[1]) : 1];
            });
          };
          'string' == typeof a.k ? s('keyword', a.k) : x(a.k).forEach(function (e) {
            s(e, a.k[e]);
          }), a.k = o;
        }
        a.lR = r(a.l || /\w+/, !0), i && (a.bK && (a.b = '\\b(' + a.bK.split(' ').join('|') + ')\\b'), a.b || (a.b = /\B|\b/), a.bR = r(a.b), a.e || a.eW || (a.e = /\B|\b/), a.e && (a.eR = r(a.e)), a.tE = t(a.e) || '', a.eW && i.tE && (a.tE += (a.e ? '|' : '') + i.tE)), a.i && (a.iR = r(a.i)), null == a.r && (a.r = 1), a.c || (a.c = []), a.c = Array.prototype.concat.apply([], a.c.map(function (e) {
          return l('self' === e ? a : e);
        })), a.c.forEach(function (e) {
          n(e, a);
        }), a.starts && n(a.starts, i);
        var c = a.c.map(function (e) {
          return e.bK ? '\\.?(' + e.b + ')\\.?' : e.b;
        }).concat([a.tE, a.i]).map(t).filter(Boolean);
        a.t = c.length ? r(c.join('|'), !0) : {
          exec: function exec() {
            return null;
          }
        };
      }
    }
    n(e);
  }
  function b(e, r, a, i) {
    function o(e, t) {
      var r, a;
      for (r = 0, a = t.c.length; a > r; r++) {
        if (n(t.c[r].bR, e)) return t.c[r];
      }
    }
    function s(e, t) {
      if (n(e.eR, t)) {
        for (; e.endsParent && e.parent;) {
          e = e.parent;
        }return e;
      }
      return e.eW ? s(e.parent, t) : void 0;
    }
    function c(e, t) {
      return !a && n(t.iR, e);
    }
    function l(e, t) {
      var r = w.cI ? t[0].toLowerCase() : t[0];
      return e.k.hasOwnProperty(r) && e.k[r];
    }
    function p(e, t, r, n) {
      var a = n ? '' : z.classPrefix,
          i = '<span class="' + a,
          o = r ? '' : B;
      return i += e + '">', i + t + o;
    }
    function f() {
      var e, r, n, a;
      if (!k.k) return t(M);
      for (a = '', r = 0, k.lR.lastIndex = 0, n = k.lR.exec(M); n;) {
        a += t(M.substring(r, n.index)), e = l(k, n), e ? (R += e[1], a += p(e[0], t(n[0]))) : a += t(n[0]), r = k.lR.lastIndex, n = k.lR.exec(M);
      }return a + t(M.substr(r));
    }
    function g() {
      var e = 'string' == typeof k.sL;
      if (e && !E[k.sL]) return t(M);
      var r = e ? b(k.sL, M, !0, x[k.sL]) : d(M, k.sL.length ? k.sL : void 0);
      return k.r > 0 && (R += r.r), e && (x[k.sL] = r.top), p(r.language, r.value, !1, !0);
    }
    function m() {
      C += null != k.sL ? g() : f(), M = '';
    }
    function h(e) {
      C += e.cN ? p(e.cN, '', !0) : '', k = Object.create(e, { parent: { value: k } });
    }
    function v(e, t) {
      if (M += e, null == t) return m(), 0;
      var r = o(t, k);
      if (r) return r.skip ? M += t : (r.eB && (M += t), m(), r.rB || r.eB || (M = t)), h(r, t), r.rB ? 0 : t.length;
      var n = s(k, t);
      if (n) {
        var a = k;
        a.skip ? M += t : (a.rE || a.eE || (M += t), m(), a.eE && (M = t));
        do {
          k.cN && (C += B), k.skip || k.sL || (R += k.r), k = k.parent;
        } while (k !== n.parent);
        return n.starts && h(n.starts, ''), a.rE ? 0 : t.length;
      }
      if (c(t, k)) throw new Error('Illegal lexeme "' + t + '" for mode "' + (k.cN || '<unnamed>') + '"');
      return M += t, t.length || 1;
    }
    var w = N(e);
    if (!w) throw new Error('Unknown language: "' + e + '"');
    u(w);
    var y,
        k = i || w,
        x = {},
        C = '';
    for (y = k; y !== w; y = y.parent) {
      y.cN && (C = p(y.cN, '', !0) + C);
    }var M = '',
        R = 0;
    try {
      for (var A, S, L = 0;;) {
        if (k.t.lastIndex = L, A = k.t.exec(r), !A) break;
        S = v(r.substring(L, A.index), A[0]), L = A.index + S;
      }
      for (v(r.substr(L)), y = k; y.parent; y = y.parent) {
        y.cN && (C += B);
      }return { r: R, value: C, language: e, top: k };
    } catch (I) {
      if (I.message && -1 !== I.message.indexOf('Illegal')) return { r: 0, value: t(r) };
      throw I;
    }
  }
  function d(e, r) {
    r = r || z.languages || x(E);
    var n = { r: 0, value: t(e) },
        a = n;
    return r.filter(N).forEach(function (t) {
      var r = b(t, e, !1);
      r.language = t, r.r > a.r && (a = r), r.r > n.r && (a = n, n = r);
    }), a.language && (n.second_best = a), n;
  }
  function p(e) {
    return z.tabReplace || z.useBR ? e.replace(A, function (e, t) {
      return z.useBR && '\n' === e ? '<br>' : z.tabReplace ? t.replace(/\t/g, z.tabReplace) : '';
    }) : e;
  }
  function f(e, t, r) {
    var n = t ? C[t] : r,
        a = [e.trim()];
    return e.match(/\bhljs\b/) || a.push('hljs'), -1 === e.indexOf(n) && a.push(n), a.join(' ').trim();
  }
  function g(e) {
    var t,
        r,
        n,
        o,
        l,
        u = i(e);
    a(u) || (z.useBR ? (t = document.createElementNS('http://www.w3.org/1999/xhtml', 'div'), t.innerHTML = e.innerHTML.replace(/\n/g, '').replace(/<br[ \/]*>/g, '\n')) : t = e, l = t.textContent, n = u ? b(u, l, !0) : d(l), r = s(t), r.length && (o = document.createElementNS('http://www.w3.org/1999/xhtml', 'div'), o.innerHTML = n.value, n.value = c(r, s(o), l)), n.value = p(n.value), e.innerHTML = n.value, e.className = f(e.className, u, n.language), e.result = { language: n.language, re: n.r }, n.second_best && (e.second_best = {
      language: n.second_best.language,
      re: n.second_best.r
    }));
  }
  function m(e) {
    z = o(z, e);
  }
  function h() {
    if (!h.called) {
      h.called = !0;
      var e = document.querySelectorAll('pre code');
      k.forEach.call(e, g);
    }
  }
  function v() {
    addEventListener('DOMContentLoaded', h, !1), addEventListener('load', h, !1);
  }
  function w(t, r) {
    var n = E[t] = r(e);
    n.aliases && n.aliases.forEach(function (e) {
      C[e] = t;
    });
  }
  function y() {
    return x(E);
  }
  function N(e) {
    return e = (e || '').toLowerCase(), E[e] || E[C[e]];
  }
  var k = [],
      x = Object.keys,
      E = {},
      C = {},
      M = /^(no-?highlight|plain|text)$/i,
      R = /\blang(?:uage)?-([\w-]+)\b/i,
      A = /((^(<[^>]+>|\t|)+|(?:\n)))/gm,
      B = '</span>',
      z = {
    classPrefix: 'hljs-',
    tabReplace: null,
    useBR: !1,
    languages: void 0
  };
  return e.highlight = b, e.highlightAuto = d, e.fixMarkup = p, e.highlightBlock = g, e.configure = m, e.initHighlighting = h, e.initHighlightingOnLoad = v, e.registerLanguage = w, e.listLanguages = y, e.getLanguage = N, e.inherit = o, e.IR = '[a-zA-Z]\\w*', e.UIR = '[a-zA-Z_]\\w*', e.NR = '\\b\\d+(\\.\\d+)?', e.CNR = '(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)', e.BNR = '\\b(0b[01]+)', e.RSR = '!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~', e.BE = { b: '\\\\[\\s\\S]', r: 0 }, e.ASM = { cN: 'string', b: "'", e: "'", i: '\\n', c: [e.BE] }, e.QSM = { cN: 'string', b: '"', e: '"', i: '\\n', c: [e.BE] }, e.PWM = {
    b: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
  }, e.C = function (t, r, n) {
    var a = e.inherit({ cN: 'comment', b: t, e: r, c: [] }, n || {});
    return a.c.push(e.PWM), a.c.push({ cN: 'doctag', b: '(?:TODO|FIXME|NOTE|BUG|XXX):', r: 0 }), a;
  }, e.CLCM = e.C('//', '$'), e.CBCM = e.C('/\\*', '\\*/'), e.HCM = e.C('#', '$'), e.NM = { cN: 'number', b: e.NR, r: 0 }, e.CNM = { cN: 'number', b: e.CNR, r: 0 }, e.BNM = { cN: 'number', b: e.BNR, r: 0 }, e.CSSNM = {
    cN: 'number',
    b: e.NR + '(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?',
    r: 0
  }, e.RM = {
    cN: 'regexp',
    b: /\//,
    e: /\/[gimuy]*/,
    i: /\n/,
    c: [e.BE, { b: /\[/, e: /\]/, r: 0, c: [e.BE] }]
  }, e.TM = { cN: 'title', b: e.IR, r: 0 }, e.UTM = { cN: 'title', b: e.UIR, r: 0 }, e.METHOD_GUARD = { b: '\\.\\s*' + e.UIR, r: 0 }, e.registerLanguage('bash', function (e) {
    var t = {
      cN: 'variable',
      v: [{ b: /\$[\w\d#@][\w\d_]*/ }, { b: /\$\{(.*?)}/ }]
    },
        r = {
      cN: 'string',
      b: /"/,
      e: /"/,
      c: [e.BE, t, { cN: 'variable', b: /\$\(/, e: /\)/, c: [e.BE] }]
    },
        n = { cN: 'string', b: /'/, e: /'/ };
    return {
      aliases: ['sh', 'zsh'],
      l: /\b-?[a-z\._]+\b/,
      k: {
        keyword: 'if then else elif fi for while in do done case esac function',
        literal: 'true false',
        built_in: 'break cd continue eval exec exit export getopts hash pwd readonly return shift test times trap umask unset alias bind builtin caller command declare echo enable help let local logout mapfile printf read readarray source type typeset ulimit unalias set shopt autoload bg bindkey bye cap chdir clone comparguments compcall compctl compdescribe compfiles compgroups compquote comptags comptry compvalues dirs disable disown echotc echoti emulate fc fg float functions getcap getln history integer jobs kill limit log noglob popd print pushd pushln rehash sched setcap setopt stat suspend ttyctl unfunction unhash unlimit unsetopt vared wait whence where which zcompile zformat zftp zle zmodload zparseopts zprof zpty zregexparse zsocket zstyle ztcp',
        _: '-ne -eq -lt -gt -f -d -e -s -l -a'
      },
      c: [{ cN: 'meta', b: /^#![^\n]+sh\s*$/, r: 10 }, {
        cN: 'function',
        b: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
        rB: !0,
        c: [e.inherit(e.TM, { b: /\w[\w\d_]*/ })],
        r: 0
      }, e.HCM, r, n, t]
    };
  }), e.registerLanguage('css', function (e) {
    var t = '[a-zA-Z-][a-zA-Z0-9_-]*',
        r = {
      b: /[A-Z\_\.\-]+\s*:/,
      rB: !0,
      e: ';',
      eW: !0,
      c: [{
        cN: 'attribute',
        b: /\S/,
        e: ':',
        eE: !0,
        starts: {
          eW: !0,
          eE: !0,
          c: [{
            b: /[\w-]+\(/,
            rB: !0,
            c: [{ cN: 'built_in', b: /[\w-]+/ }, { b: /\(/, e: /\)/, c: [e.ASM, e.QSM] }]
          }, e.CSSNM, e.QSM, e.ASM, e.CBCM, { cN: 'number', b: '#[0-9A-Fa-f]+' }, { cN: 'meta', b: '!important' }]
        }
      }]
    };
    return {
      cI: !0,
      i: /[=\/|'\$]/,
      c: [e.CBCM, { cN: 'selector-id', b: /#[A-Za-z0-9_-]+/ }, { cN: 'selector-class', b: /\.[A-Za-z0-9_-]+/ }, { cN: 'selector-attr', b: /\[/, e: /\]/, i: '$' }, { cN: 'selector-pseudo', b: /:(:)?[a-zA-Z0-9\_\-\+\(\)"'.]+/ }, { b: '@(font-face|page)', l: '[a-z-]+', k: 'font-face page' }, {
        b: '@',
        e: '[{;]',
        i: /:/,
        c: [{ cN: 'keyword', b: /\w+/ }, { b: /\s/, eW: !0, eE: !0, r: 0, c: [e.ASM, e.QSM, e.CSSNM] }]
      }, { cN: 'selector-tag', b: t, r: 0 }, { b: '{', e: '}', i: /\S/, c: [e.CBCM, r] }]
    };
  }), e.registerLanguage('javascript', function (e) {
    var t = '[A-Za-z$_][0-9A-Za-z$_]*',
        r = {
      keyword: 'in of if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const export super debugger as async await static import from as',
      literal: 'true false null undefined NaN Infinity',
      built_in: 'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document Symbol Set Map WeakSet WeakMap Proxy Reflect Promise'
    },
        n = {
      cN: 'number',
      v: [{ b: '\\b(0[bB][01]+)' }, { b: '\\b(0[oO][0-7]+)' }, { b: e.CNR }],
      r: 0
    },
        a = { cN: 'subst', b: '\\$\\{', e: '\\}', k: r, c: [] },
        i = { cN: 'string', b: '`', e: '`', c: [e.BE, a] };
    a.c = [e.ASM, e.QSM, i, n, e.RM];
    var o = a.c.concat([e.CBCM, e.CLCM]);
    return {
      aliases: ['js', 'jsx'],
      k: r,
      c: [{ cN: 'meta', r: 10, b: /^\s*['"]use (strict|asm)['"]/ }, { cN: 'meta', b: /^#!/, e: /$/ }, e.ASM, e.QSM, i, e.CLCM, e.CBCM, n, {
        b: /[{,]\s*/,
        r: 0,
        c: [{ b: t + '\\s*:', rB: !0, r: 0, c: [{ cN: 'attr', b: t, r: 0 }] }]
      }, {
        b: '(' + e.RSR + '|\\b(case|return|throw)\\b)\\s*',
        k: 'return throw case',
        c: [e.CLCM, e.CBCM, e.RM, {
          cN: 'function',
          b: '(\\(.*?\\)|' + t + ')\\s*=>',
          rB: !0,
          e: '\\s*=>',
          c: [{
            cN: 'params',
            v: [{ b: t }, { b: /\(\s*\)/ }, { b: /\(/, e: /\)/, eB: !0, eE: !0, k: r, c: o }]
          }]
        }, {
          b: /</,
          e: /(\/\w+|\w+\/)>/,
          sL: 'xml',
          c: [{ b: /<\w+\s*\/>/, skip: !0 }, {
            b: /<\w+/,
            e: /(\/\w+|\w+\/)>/,
            skip: !0,
            c: [{ b: /<\w+\s*\/>/, skip: !0 }, 'self']
          }]
        }],
        r: 0
      }, {
        cN: 'function',
        bK: 'function',
        e: /\{/,
        eE: !0,
        c: [e.inherit(e.TM, { b: t }), { cN: 'params', b: /\(/, e: /\)/, eB: !0, eE: !0, c: o }],
        i: /\[|%/
      }, { b: /\$[(.]/ }, e.METHOD_GUARD, {
        cN: 'class',
        bK: 'class',
        e: /[{;=]/,
        eE: !0,
        i: /[:"\[\]]/,
        c: [{ bK: 'extends' }, e.UTM]
      }, { bK: 'constructor', e: /\{/, eE: !0 }],
      i: /#(?!!)/
    };
  }), e.registerLanguage('xml', function (e) {
    var t = '[A-Za-z0-9\\._:-]+',
        r = {
      eW: !0,
      i: /</,
      r: 0,
      c: [{ cN: 'attr', b: t, r: 0 }, {
        b: /=\s*/,
        r: 0,
        c: [{
          cN: 'string',
          endsParent: !0,
          v: [{ b: /"/, e: /"/ }, { b: /'/, e: /'/ }, { b: /[^\s"'=<>`]+/ }]
        }]
      }]
    };
    return {
      aliases: ['html', 'xhtml', 'rss', 'atom', 'xjb', 'xsd', 'xsl', 'plist'],
      cI: !0,
      c: [{
        cN: 'meta',
        b: '<!DOCTYPE',
        e: '>',
        r: 10,
        c: [{ b: '\\[', e: '\\]' }]
      }, e.C('<!--', '-->', { r: 10 }), { b: '<\\!\\[CDATA\\[', e: '\\]\\]>', r: 10 }, { cN: 'meta', b: /<\?xml/, e: /\?>/, r: 10 }, {
        b: /<\?(php)?/,
        e: /\?>/,
        sL: 'php',
        c: [{ b: '/\\*', e: '\\*/', skip: !0 }]
      }, {
        cN: 'tag',
        b: '<style(?=\\s|>|$)',
        e: '>',
        k: { name: 'style' },
        c: [r],
        starts: { e: '</style>', rE: !0, sL: ['css', 'xml'] }
      }, {
        cN: 'tag',
        b: '<script(?=\\s|>|$)',
        e: '>',
        k: { name: 'script' },
        c: [r],
        starts: {
          e: '</script>',
          rE: !0,
          sL: ['actionscript', 'javascript', 'handlebars', 'xml']
        }
      }, {
        cN: 'tag',
        b: '</?',
        e: '/?>',
        c: [{ cN: 'name', b: /[^\/><\s]+/, r: 0 }, r]
      }]
    };
  }), e.registerLanguage('markdown', function (e) {
    return {
      aliases: ['md', 'mkdown', 'mkd'],
      c: [{
        cN: 'section',
        v: [{ b: '^#{1,6}', e: '$' }, { b: '^.+?\\n[=-]{2,}$' }]
      }, { b: '<', e: '>', sL: 'xml', r: 0 }, { cN: 'bullet', b: '^([*+-]|(\\d+\\.))\\s+' }, { cN: 'strong', b: '[*_]{2}.+?[*_]{2}' }, { cN: 'emphasis', v: [{ b: '\\*.+?\\*' }, { b: '_.+?_', r: 0 }] }, { cN: 'quote', b: '^>\\s+', e: '$' }, {
        cN: 'code',
        v: [{ b: '^```w*s*$', e: '^```s*$' }, { b: '`.+?`' }, { b: '^( {4}|	)', e: '$', r: 0 }]
      }, { b: '^[-\\*]{3,}', e: '$' }, {
        b: '\\[.+?\\][\\(\\[].*?[\\)\\]]',
        rB: !0,
        c: [{ cN: 'string', b: '\\[', e: '\\]', eB: !0, rE: !0, r: 0 }, { cN: 'link', b: '\\]\\(', e: '\\)', eB: !0, eE: !0 }, { cN: 'symbol', b: '\\]\\[', e: '\\]', eB: !0, eE: !0 }],
        r: 10
      }, {
        b: /^\[[^\n]+\]:/,
        rB: !0,
        c: [{ cN: 'symbol', b: /\[/, e: /\]/, eB: !0, eE: !0 }, { cN: 'link', b: /:\s*/, e: /$/, eB: !0 }]
      }]
    };
  }), e.registerLanguage('scss', function (e) {
    var t = '[a-zA-Z-][a-zA-Z0-9_-]*',
        r = { cN: 'variable', b: '(\\$' + t + ')\\b' },
        n = { cN: 'number', b: '#[0-9A-Fa-f]+' };
    ({
      cN: 'attribute',
      b: '[A-Z\\_\\.\\-]+',
      e: ':',
      eE: !0,
      i: '[^\\s]',
      starts: {
        eW: !0,
        eE: !0,
        c: [n, e.CSSNM, e.QSM, e.ASM, e.CBCM, { cN: 'meta', b: '!important' }]
      }
    });
    return {
      cI: !0,
      i: "[=/|']",
      c: [e.CLCM, e.CBCM, { cN: 'selector-id', b: '\\#[A-Za-z0-9_-]+', r: 0 }, { cN: 'selector-class', b: '\\.[A-Za-z0-9_-]+', r: 0 }, { cN: 'selector-attr', b: '\\[', e: '\\]', i: '$' }, {
        cN: 'selector-tag',
        b: '\\b(a|abbr|acronym|address|area|article|aside|audio|b|base|big|blockquote|body|br|button|canvas|caption|cite|code|col|colgroup|command|datalist|dd|del|details|dfn|div|dl|dt|em|embed|fieldset|figcaption|figure|footer|form|frame|frameset|(h[1-6])|head|header|hgroup|hr|html|i|iframe|img|input|ins|kbd|keygen|label|legend|li|link|map|mark|meta|meter|nav|noframes|noscript|object|ol|optgroup|option|output|p|param|pre|progress|q|rp|rt|ruby|samp|script|section|select|small|span|strike|strong|style|sub|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|tt|ul|var|video)\\b',
        r: 0
      }, {
        b: ':(visited|valid|root|right|required|read-write|read-only|out-range|optional|only-of-type|only-child|nth-of-type|nth-last-of-type|nth-last-child|nth-child|not|link|left|last-of-type|last-child|lang|invalid|indeterminate|in-range|hover|focus|first-of-type|first-line|first-letter|first-child|first|enabled|empty|disabled|default|checked|before|after|active)'
      }, {
        b: '::(after|before|choices|first-letter|first-line|repeat-index|repeat-item|selection|value)'
      }, r, {
        cN: 'attribute',
        b: '\\b(z-index|word-wrap|word-spacing|word-break|width|widows|white-space|visibility|vertical-align|unicode-bidi|transition-timing-function|transition-property|transition-duration|transition-delay|transition|transform-style|transform-origin|transform|top|text-underline-position|text-transform|text-shadow|text-rendering|text-overflow|text-indent|text-decoration-style|text-decoration-line|text-decoration-color|text-decoration|text-align-last|text-align|tab-size|table-layout|right|resize|quotes|position|pointer-events|perspective-origin|perspective|page-break-inside|page-break-before|page-break-after|padding-top|padding-right|padding-left|padding-bottom|padding|overflow-y|overflow-x|overflow-wrap|overflow|outline-width|outline-style|outline-offset|outline-color|outline|orphans|order|opacity|object-position|object-fit|normal|none|nav-up|nav-right|nav-left|nav-index|nav-down|min-width|min-height|max-width|max-height|mask|marks|margin-top|margin-right|margin-left|margin-bottom|margin|list-style-type|list-style-position|list-style-image|list-style|line-height|letter-spacing|left|justify-content|initial|inherit|ime-mode|image-orientation|image-resolution|image-rendering|icon|hyphens|height|font-weight|font-variant-ligatures|font-variant|font-style|font-stretch|font-size-adjust|font-size|font-language-override|font-kerning|font-feature-settings|font-family|font|float|flex-wrap|flex-shrink|flex-grow|flex-flow|flex-direction|flex-basis|flex|filter|empty-cells|display|direction|cursor|counter-reset|counter-increment|content|column-width|column-span|column-rule-width|column-rule-style|column-rule-color|column-rule|column-gap|column-fill|column-count|columns|color|clip-path|clip|clear|caption-side|break-inside|break-before|break-after|box-sizing|box-shadow|box-decoration-break|bottom|border-width|border-top-width|border-top-style|border-top-right-radius|border-top-left-radius|border-top-color|border-top|border-style|border-spacing|border-right-width|border-right-style|border-right-color|border-right|border-radius|border-left-width|border-left-style|border-left-color|border-left|border-image-width|border-image-source|border-image-slice|border-image-repeat|border-image-outset|border-image|border-color|border-collapse|border-bottom-width|border-bottom-style|border-bottom-right-radius|border-bottom-left-radius|border-bottom-color|border-bottom|border|background-size|background-repeat|background-position|background-origin|background-image|background-color|background-clip|background-attachment|background-blend-mode|background|backface-visibility|auto|animation-timing-function|animation-play-state|animation-name|animation-iteration-count|animation-fill-mode|animation-duration|animation-direction|animation-delay|animation|align-self|align-items|align-content)\\b',
        i: '[^\\s]'
      }, {
        b: '\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b'
      }, {
        b: ':',
        e: ';',
        c: [r, n, e.CSSNM, e.QSM, e.ASM, { cN: 'meta', b: '!important' }]
      }, {
        b: '@',
        e: '[{;]',
        k: 'mixin include extend for if else each while charset import debug media page content font-face namespace warn',
        c: [r, e.QSM, e.ASM, n, e.CSSNM, { b: '\\s[A-Za-z0-9_.-]+', r: 0 }]
      }]
    };
  }), e.registerLanguage('shell', function (e) {
    return {
      aliases: ['console'],
      c: [{
        cN: 'meta',
        b: '^\\s{0,3}[\\w\\d\\[\\]()@-]*[>%$#]',
        starts: { e: '$', sL: 'bash' }
      }]
    };
  }), e.registerLanguage('typescript', function (e) {
    var t = {
      keyword: 'in if for while finally var new function do return void else break catch instanceof with throw case default try this switch continue typeof delete let yield const class public private protected get set super static implements enum export import declare type namespace abstract as from extends async await',
      literal: 'true false null undefined NaN Infinity',
      built_in: 'eval isFinite isNaN parseFloat parseInt decodeURI decodeURIComponent encodeURI encodeURIComponent escape unescape Object Function Boolean Error EvalError InternalError RangeError ReferenceError StopIteration SyntaxError TypeError URIError Number Math Date String RegExp Array Float32Array Float64Array Int16Array Int32Array Int8Array Uint16Array Uint32Array Uint8Array Uint8ClampedArray ArrayBuffer DataView JSON Intl arguments require module console window document any number boolean string void Promise'
    };
    return {
      aliases: ['ts'],
      k: t,
      c: [{ cN: 'meta', b: /^\s*['"]use strict['"]/ }, e.ASM, e.QSM, {
        cN: 'string',
        b: '`',
        e: '`',
        c: [e.BE, { cN: 'subst', b: '\\$\\{', e: '\\}' }]
      }, e.CLCM, e.CBCM, {
        cN: 'number',
        v: [{ b: '\\b(0[bB][01]+)' }, { b: '\\b(0[oO][0-7]+)' }, { b: e.CNR }],
        r: 0
      }, {
        b: '(' + e.RSR + '|\\b(case|return|throw)\\b)\\s*',
        k: 'return throw case',
        c: [e.CLCM, e.CBCM, e.RM, {
          cN: 'function',
          b: '(\\(.*?\\)|' + e.IR + ')\\s*=>',
          rB: !0,
          e: '\\s*=>',
          c: [{
            cN: 'params',
            v: [{ b: e.IR }, { b: /\(\s*\)/ }, {
              b: /\(/,
              e: /\)/,
              eB: !0,
              eE: !0,
              k: t,
              c: ['self', e.CLCM, e.CBCM]
            }]
          }]
        }],
        r: 0
      }, {
        cN: 'function',
        b: 'function',
        e: /[\{;]/,
        eE: !0,
        k: t,
        c: ['self', e.inherit(e.TM, { b: /[A-Za-z$_][0-9A-Za-z$_]*/ }), {
          cN: 'params',
          b: /\(/,
          e: /\)/,
          eB: !0,
          eE: !0,
          k: t,
          c: [e.CLCM, e.CBCM],
          i: /["'\(]/
        }],
        i: /%/,
        r: 0
      }, {
        bK: 'constructor',
        e: /\{/,
        eE: !0,
        c: ['self', {
          cN: 'params',
          b: /\(/,
          e: /\)/,
          eB: !0,
          eE: !0,
          k: t,
          c: [e.CLCM, e.CBCM],
          i: /["'\(]/
        }]
      }, { b: /module\./, k: { built_in: 'module' }, r: 0 }, { bK: 'module', e: /\{/, eE: !0 }, { bK: 'interface', e: /\{/, eE: !0, k: 'interface extends' }, { b: /\$[(.]/ }, { b: '\\.' + e.IR, r: 0 }, { cN: 'meta', b: '@[A-Za-z]+' }]
    };
  }), e;
});

/***/ }),

/***/ "./util/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return encode; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDownloadBucket;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return packageJSONLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return packageLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return searchLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return prefixURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return safeMarkdown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return i18nReplaceVars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isKnownRepositoryHost; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_unfetch__ = __webpack_require__("../../node_modules/unfetch/dist/unfetch.es.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked__ = __webpack_require__("../../node_modules/marked/lib/marked.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xss__ = __webpack_require__("../../node_modules/xss/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_xss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_xss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_unescape_html__ = __webpack_require__("../../node_modules/unescape-html/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_unescape_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_unescape_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatKeywords__ = __webpack_require__("./util/formatKeywords.js");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__formatKeywords__["a"]; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









var isEmpty = function isEmpty(item) {
  return typeof item === 'undefined' || item.length < 1;
};

var encode = function encode(val) {
  return encodeURIComponent(val);
};

function getDownloadBucket(dl) {
  if (dl < 1000) {
    return null;
  } else if (dl < 5000) {
    return 'hot-t1';
  } else if (dl < 25000) {
    return 'hot-t2';
  } else if (dl < 1000000) {
    return 'hot-t3';
  } else {
    return 'hot-t4';
  }
}

var packageJSONLink = function packageJSONLink(packageName) {
  return {
    packageJSONLink: 'https://cdn.jsdelivr.net/npm/' + packageName + '/package.json'
  };
};

var packageLink = function packageLink(name) {
  return window.i18n.url_base + '/package' + ( true ? '/' : '?') + name;
};

var searchLink = function searchLink(_ref) {
  var query = _ref.query,
      keyword = _ref.keyword;
  return window.i18n.url_base + '/packages?' + (query ? 'q=' + query : '') + (keyword ? '&keywords%5B0%5D=' + keyword : '');
};

var prefixURL = function prefixURL(url, _ref2) {
  var base = _ref2.base,
      user = _ref2.user,
      project = _ref2.project,
      head = _ref2.head,
      path = _ref2.path;

  if (url.indexOf('//') > 0) {
    return url;
  } else {
    return new URL((path ? path.replace(/^\//, '') + '/' : '') + url.replace(/^(\.?\/?)/, ''), base + '/' + user + '/' + project + '/' + (path ? '' : head + '/'));
  }
};

var status = function status(res) {
  return new Promise(function (resolve, reject) {
    if (res.status >= 200 && res.status < 300) {
      // GitHub will return status 202 or 204 if things like contributor activity are
      // valid, but not yet computed, and will return an empty response
      if (res.status === 202 || res.status === 204) {
        reject(res);
      }
      resolve(res);
    } else {
      reject(res);
    }
  });
};

var get = function get(_ref3) {
  var url = _ref3.url,
      type = _ref3.type,
      headers = _ref3.headers,
      rest = _objectWithoutProperties(_ref3, ['url', 'type', 'headers']);

  return Object(__WEBPACK_IMPORTED_MODULE_1_unfetch__["a" /* default */])(url, _extends({ headers: headers }, rest)).then(status).then(function (res) {
    return res[type]();
  }).catch(function (err) {
    // in case it's a useless response by GitHub, tell the caller to retry
    if (err.status === 202 || err.status === 204) {
      throw 'retry';
    } else {
      console.warn(err);
    }
  });
};


var inlineRenderer = new __WEBPACK_IMPORTED_MODULE_2_marked___default.a.Renderer();
inlineRenderer.paragraph = function (text) {
  return text;
};

var safeMarkdown = function safeMarkdown(input) {
  return {
    __html: __WEBPACK_IMPORTED_MODULE_3_xss___default()(__WEBPACK_IMPORTED_MODULE_2_marked___default()(__WEBPACK_IMPORTED_MODULE_4_unescape_html___default()(input), { renderer: inlineRenderer })) || ' '
  };
};

var i18nReplaceVars = function i18nReplaceVars(message, vars) {
  return message && message.replace(/{([^}]+)}/gi, function (match, varName) {
    return vars[varName] || match;
  });
};

// Contains the repositories that we know how to handle
var knownRepositoryHosts = new Set(['github.com', 'gitlab.com', 'bitbucket.org']);

var isKnownRepositoryHost = function isKnownRepositoryHost(host) {
  return knownRepositoryHosts.has(host);
};

/***/ }),

/***/ "./util/production.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fillLanguageDropdown;
if (!NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

function fillLanguageDropdown() {
  // Takes over language dropdown to set cookie
  var langMenu = document.getElementById('dropdownNavLanguageMenu');
  if (langMenu) {
    var langMenuItems = langMenu.querySelectorAll('dropdown-item');

    langMenuItems.forEach(function (langMenuItem) {
      langMenuItem.addEventListener('click', function (event) {
        event.preventDefault();
        var target = event.currentTarget;
        var lang = target.dataset.lang;
        document.cookie = 'nf_lang=' + lang;
        location.reload();
      });
    });
  }
}

/***/ }),

/***/ "./util/schema.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  activity: Array.from({ length: 12 }, function () {
    return { total: 0 };
  }),
  changelogFilename: '',
  created: 1489597229367,
  dependencies: {},
  devDependencies: {},
  dependents: 0,
  deprecated: false,
  description: '…',
  downloadsLast30Days: 0,
  downloadsRatio: 0,
  jsDelivrHits: 0,
  github: {
    stargazers_count: 0
  },
  gitlab: {
    star_count: 0
  },
  bundlesize: undefined,
  homepage: '',
  humanDependents: '0',
  humanDownloadsLast30Days: '0',
  keywords: [],
  lastCrawl: '',
  lastPublisher: {
    name: '',
    email: '',
    avatar: 'https://avatars3.githubusercontent.com/u/22247014?v=3&s=200',
    link: ''
  },
  license: '',
  modified: 1489597229367,
  name: '…',
  objectID: '',
  owner: {
    name: '',
    avatar: 'https://avatars3.githubusercontent.com/u/22247014?v=3&s=200',
    link: ''
  },
  owners: [{
    name: '',
    email: '',
    avatar: 'https://avatars3.githubusercontent.com/u/22247014?v=3&s=200',
    link: ''
  }],
  popular: false,
  popularName: '',
  readme: '',
  version: '',
  versions: {},
  tags: {},
  types: {},
  loaded: false
});

/***/ }),

/***/ "./util/serviceStatus.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = checkServiceStatus;
/* unused harmony export showStatusMessage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_unfetch__ = __webpack_require__("../../node_modules/unfetch/dist/unfetch.es.js");

function checkServiceStatus() {
  Object(__WEBPACK_IMPORTED_MODULE_0_unfetch__["a" /* default */])('https://status.yarnpkg.com/api/v1/status').then(function (res) {
    return res.json();
  }).then(function (_ref) {
    var _ref$data = _ref.data,
        status = _ref$data.status,
        message = _ref$data.message;

    if (status !== 'success') {
      showStatusMessage(message);
    }
  }).catch(function (ex) {
    return console.warn('Could not fetch service status: ' + ex.message);
  });
}

function showStatusMessage(message) {
  var alertEl = document.createElement('div');
  alertEl.className = 'alert alert-danger alert-dismissible fade hide';
  alertEl.setAttribute('role', 'alert');
  alertEl.innerHTML = '\n    <button type="button" class="close" data-dismiss="alert" aria-label="Close">\n      <span aria-hidden="true">&times;</span>\n    </button>\n    <strong>Status:</strong>\n    <span class="system-status"></span>.\n    <a href="https://status.yarnpkg.com/" class="alert-link">Read More &rarr;</a>';

  var buttonEl = alertEl.querySelector('button');
  buttonEl.addEventListener('click', function () {
    buttonEl.parentNode.parentNode.removeChild(buttonEl.parentNode);
  });

  // Set text using textContent so it's not vulnerable to XSS
  var messageEl = alertEl.querySelector('.system-status');
  messageEl.textContent = message;

  // Insert into the hero, above the title
  var containerEl = document.querySelector('.hero > .container');
  if (!containerEl) {
    containerEl = document.body;
  }
  containerEl.insertBefore(alertEl, containerEl.firstChild);

  // Fade the alert in
  window.setTimeout(function () {
    return alertEl.classList.remove('hide');
  }, 0);
  window.setTimeout(function () {
    return alertEl.classList.add('show');
  }, 20);
}

/***/ }),

/***/ "./util/withUrlSync.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("../../node_modules/react/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("../../node_modules/qs/lib/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var updateAfter = 700;
var searchStateToQueryString = function searchStateToQueryString(searchState) {
  return _extends({
    q: searchState.query,
    p: searchState.page
  }, searchState.refinementList && _extends({}, searchState.refinementList['owner.name'] && {
    owner: searchState.refinementList['owner.name']
  }, searchState.refinementList.keywords && {
    keywords: searchState.refinementList.keywords
  }));
};

var searchStateToUrl = function searchStateToUrl(searchState) {
  return searchState ? window.i18n.url_base + '/packages?' + __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(searchStateToQueryString(searchState)) : '';
};

var queryStringToSearchState = function queryStringToSearchState(queryString) {
  var _qs$parse = __WEBPACK_IMPORTED_MODULE_1_qs___default.a.parse(queryString),
      p = _qs$parse.p,
      q = _qs$parse.q,
      owner = _qs$parse.owner,
      keywords = _qs$parse.keywords;

  return {
    query: q,
    page: p || 1,
    refinementList: _extends({}, keywords && { keywords: keywords }, owner && { 'owner.name': owner })
  };
};

var originalPathName = location.pathname;

/* harmony default export */ __webpack_exports__["a"] = (function (App) {
  return function (_Component) {
    _inherits(_class2, _Component);

    function _class2() {
      _classCallCheck(this, _class2);

      var _this = _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this));

      _this.onSearchStateChange = function (searchState) {
        clearTimeout(_this.debouncedSetState);

        if (searchState.query === '') {
          if (location.pathname !== originalPathName) {
            window.history.pushState(null, 'Search packages | Yarn', originalPathName);
          }
        } else {
          _this.debouncedSetState = setTimeout(function () {
            window.history.pushState(searchState, 'Search packages | Yarn', searchStateToUrl(searchState));
          }, updateAfter);
        }

        _this.setState({ searchState: searchState });
      };

      _this.state = {
        searchState: queryStringToSearchState(location.search.slice(1))
      };
      window.addEventListener('popstate', function (_ref) {
        var searchState = _ref.state;

        // check we are on a search result
        if (searchState !== null) {
          _this.setState({ searchState: searchState });
          return;
        }

        _this.setState({ searchState: { query: '', page: 1 } });
      });
      return _this;
    }

    _createClass(_class2, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(App, _extends({}, this.props, {
          searchState: this.state.searchState,
          onSearchStateChange: this.onSearchStateChange.bind(this),
          createURL: searchStateToUrl
        }));
      }
    }]);

    return _class2;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
});

/***/ })

},["./common.js"]);


// WEBPACK FOOTER //
// common.2a29ed27bfa751cd6609.js